// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.product-selection-page {
  margin-bottom: 60px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
@media (max-width: 1024px) {
  .product-selection-page {
    margin-left: -10px;
  }
}
.product-selection-page .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .product-selection-page .btn-link {
    margin-right: 60px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .product-selection-page .btn-link {
    margin-right: 75px;
  }
}
@media (max-width: 1024px) {
  .product-selection-page .pull-right {
    float: right;
    width: 280px;
    margin-right: -35px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .product-selection-page .pull-right {
    margin-right: -11px;
  }
}
@media (max-width: 600px) {
  .product-selection-page .alert {
    margin-left: -44px;
    margin-right: -25px;
    border-radius: 8px;
  }
  .product-selection-page .alert div:first-child {
    border-radius: 8px 0 0 8px;
  }
  .product-selection-page .alert .close {
    right: 30px;
    top: -5px;
  }
}
.product-selection-page .content-text {
  position: relative;
  height: 139px;
  width: 540px;
  text-align: center;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .product-selection-page .content-text {
    height: 185px;
    width: 325px;
    text-align: center;
    font-weight: bold;
  }
}
.product-selection-page .text-box {
  width: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  margin-left: -30px;
  margin-top: 10px;
}
@media (max-width: 1024px) {
  .product-selection-page .text-box {
    width: fit-content;
    flex-direction: column;
    margin: 20px;
    height: 182px;
    margin-top: -3px;
  }
}
.product-selection-page .text1 {
  width: 120px;
  height: 61px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .product-selection-page .text1 {
    width: 100%;
    height: 31px;
    font-size: 14px;
    margin-top: 10px;
  }
}
.product-selection-page .text2 {
  width: 120px;
  height: 61px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .product-selection-page .text2 {
    width: 187px;
    height: 31px;
    font-size: 14px;
    margin-top: 10px;
  }
}
.product-selection-page .text3 {
  width: 120px;
  height: 61px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .product-selection-page .text3 {
    width: 187px;
    height: 31px;
    font-size: 14px;
    margin-top: -5px;
  }
}
.product-selection-page .text4 {
  width: 120px;
  height: 61px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .product-selection-page .text4 {
    width: 187px;
    height: 31px;
    font-size: 14px;
    margin-top: 15px;
  }
}
.product-selection-page .abmapplyacct:hover {
  cursor: pointer;
  text-decoration: underline;
}
.product-selection-page .tooltipActive + .helper-text {
  padding: 10px;
  display: inline-block;
  position: absolute;
  width: 280px !important;
  font-size: 11px;
  border-radius: 7px;
  background-color: white;
  border: 1px solid var(--Controls-Border-Floating, #DCDFE3);
  box-shadow: 0px 2px 12px 0px rgba(80, 127, 171, 0.059);
  box-shadow: 0px 2px 4px -1px rgba(37, 48, 58, 0.0588235294);
  box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);
  display: inline-table;
  bottom: 100%;
  margin-bottom: -2px;
  background-color: white;
  color: black;
  top: 54.5%;
  left: 44%;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .product-selection-page .tooltipActive + .helper-text {
    margin-top: 0px;
    margin-bottom: -2px;
    background-color: white;
    top: 33% !important;
    left: 32% !important;
  }
}
@media (max-width: 1024px) {
  .product-selection-page .tooltipActive + .helper-text {
    z-index: 1;
    margin-top: 0px;
  }
}
.product-selection-page .tooltip-input {
  right: -50px;
  bottom: 8px;
  width: 30px;
}
@media (max-width: 1024px) {
  .product-selection-page .tooltip-input {
    right: -200px;
    bottom: 50px;
    width: 35px;
  }
}
.product-selection-page .content-wrapper {
  position: relative;
  height: 200px;
  width: 540px;
  padding: 15px;
  margin-left: 10px;
}
@media (max-width: 1024px) {
  .product-selection-page .content-wrapper {
    display: flex;
    flex-direction: row;
    padding: 0px !important;
    width: 300px;
  }
}
.product-selection-page .ng-modal-number-container {
  margin-top: 25px;
  background-color: #f1f2f3;
  border-top: 5px solid #1483d9;
  width: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
@media (max-width: 1024px) {
  .product-selection-page .ng-modal-number-container {
    flex-direction: column;
    border-top: px solid #1483d9;
    height: 155px;
  }
}
.product-selection-page .numberContainer {
  margin-top: -23px;
}
.product-selection-page .numberIcon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 18px;
  color: #f1f2f3;
  line-height: 42px;
  text-align: center;
  background: #1483d9;
  border: 2px solid #1483d9;
}
@media (max-width: 1024px) {
  .product-selection-page .numberIcon {
    width: 32px;
    height: 32px;
    font-size: 16px;
    text-align: center;
    line-height: 32px;
  }
}
.product-selection-page .supportArticle h3 {
  font: 24px;
  margin-top: 20px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
.product-selection-page .supportArticle ul {
  list-style-type: disc;
}
.product-selection-page .supportArticle li {
  list-style-type: disc;
}
.product-selection-page .supportArticle .padding {
  padding-left: 38px;
}
@media (max-width: 1024px) {
  .product-selection-page {
    margin-bottom: 30px;
    padding-top: 50px;
  }
}

.btn-abm {
  border: 1px solid var(--unnamed-color-1483d9);
  background: #1483D9 0% 0% no-repeat padding-box;
  border: 1px solid #1483D9;
  border-radius: 6px;
  opacity: 1;
  font-size: 17px;
}

#ztpradio {
  margin-top: -95px;
  margin-left: -5px;
}
@media (max-width: 1024px) {
  #ztpradio {
    margin-top: -100px;
    margin-left: 70px;
  }
}

.container-flex {
  display: inline-flex !important;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-content: center;
  align-items: flex-start;
  margin-left: -20px;
  width: 100%;
  padding-top: 15px;
}
@media (max-width: 1024px) {
  .container-flex {
    width: 100%;
    margin-left: -60px;
    flex-direction: column;
  }
}
@media only screen and (max-width: 1020px) and (min-width: 400px) {
  .container-flex {
    margin-left: -50px;
  }
}

.container-flex > div {
  margin: 10px;
}

@media only screen and (max-width: 1020px) and (min-width: 400px) {
  .flex-box {
    margin-left: 0px;
  }
}

.container1 {
  top: 356px;
  left: 421px;
  width: 186px;
  height: 200px;
  padding: 20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #d2d2d2;
  opacity: 1;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
@media (max-width: 1024px) {
  .container1 {
    width: 325px;
    height: 170px;
  }
}

@media (max-width: 1024px) {
  .conditional-display {
    visibility: hidden;
  }
}
.container1.selected-border {
  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);
  border-bottom: none;
}

.container2 {
  top: 356px;
  left: 626px;
  width: 186px;
  height: 200px;
  padding: 20px;
  padding-left: 13px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #d2d2d2;
  opacity: 1;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
@media (max-width: 1024px) {
  .container2 {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-left: 50px;
    width: 325px;
    height: 160px;
  }
}

.container2.selected-border {
  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);
  border-bottom: none;
}

.container3 {
  top: 356px;
  left: 835px;
  width: 186px;
  height: 200px;
  padding: 20px;
  padding-left: 13px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #d2d2d2;
  opacity: 1;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
@media (max-width: 1024px) {
  .container3 {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-left: 50px;
    width: 325px;
    height: 160px;
  }
}

.container3.selected-border {
  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);
  border-bottom: none;
}

.row {
  margin-left: 0px;
  margin-right: 0px !important;
}
.enroll {
  top: 381px;
  left: 491px;
  padding-left: 45px;
  width: 46px;
  height: 15px;
  font-size: 12px;
  text-align: center;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  letter-spacing: 0.4px;
  color: #000000;
  opacity: 1;
}
@media (max-width: 1024px) {
  .enroll {
    padding-left: 65px;
  }
}

.service {
  top: 424px;
  left: 442px;
  width: 144px;
  height: 45px;
  font-size: 18px;
  text-align: center;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  letter-spacing: 0.6px;
  color: #000000;
  opacity: 1;
}
.service p {
  margin-bottom: 0px !important;
}
@media (max-width: 1024px) {
  .service {
    width: 192px;
    margin-left: 40px;
  }
}

.radio-button {
  top: 495px;
  left: 501px;
  width: 25px;
  height: 25px;
  padding: 20px 0 0 60px;
}
@media (max-width: 1024px) {
  .radio-button {
    margin-top: -1px;
    margin-left: 60px;
  }
}

.msg-box {
  top: 577px;
  left: 421px;
  width: 602px;
  background: #F1F2F3 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 7px;
  padding-top: 30px;
  padding-bottom: 30px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
.msg-box p {
  margin-bottom: 10px !important;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .msg-box {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-top: -25px;
    margin-left: 5px;
    width: 325px;
    font-size: 16px;
  }
  .msg-box p {
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 1024px) and (max-width: 1220px) and (min-width: 920px) {
  .msg-box {
    width: 325px;
  }
}

.msg-box1 {
  top: 577px;
  left: 421px;
  width: 602px;
  background: #F1F2F3 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 20px 20px 30px 20;
  margin-top: 20px;
  margin-bottom: 30px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
.msg-box1 p {
  margin-bottom: 5px;
}
@media (max-width: 1024px) {
  .msg-box1 {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-top: 10px;
    width: 325px;
  }
  .msg-box1 p {
    margin-bottom: 5px;
  }
}
@media only screen and (max-width: 700px) and (min-width: 920px) {
  .msg-box1 {
    width: 325px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 1020px) {
  .msg-box1 {
    width: 445px;
  }
}

.msg-box1-zte {
  top: 577px;
  left: 421px;
  width: 598px;
  background: #F1F2F3 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 7px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
.msg-box1-zte p {
  margin-bottom: 10px;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .msg-box1-zte {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-top: 10px;
    width: 325px;
  }
  .msg-box1-zte p {
    margin-bottom: 5px;
  }
}
@media only screen and (max-width: 700px) and (min-width: 920px) {
  .msg-box1-zte {
    width: 325px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 1020px) {
  .msg-box1-zte {
    width: 445px;
  }
}

.field {
  top: 693px;
  left: 437px;
  width: 560px !important;
  height: 36px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border-radius: 5px !important;
}
@media (max-width: 1024px) {
  .field {
    width: 280px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .field {
    width: 280px !important;
  }
}

.disableLabel {
  cursor: auto;
}

h1 {
  margin-top: 30px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  hr {
    width: 325px;
    margin-left: -46px !important;
  }
}
@media only screen and (max-width: 1020px) and (min-width: 400px) {
  hr {
    width: 325px;
    margin-left: -46px !important;
  }
}

h3 {
  font: 24px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  margin-top: 30px;
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  h3 {
    font: 16px;
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  }
}

.heading-small-content-ibm {
  font: 18px !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  margin-bottom: 10px;
}
@media (max-width: 1024px) {
  .heading-small-content-ibm {
    font-size: 14px !important;
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  }
}

.productselection-description1 {
  margin-bottom: 30px;
  letter-spacing: var(--unnamed-character-spacing-0-53);
  font-size: 16px !important;
}
@media (max-width: 1024px) {
  .productselection-description1 {
    width: 325px;
    margin-left: -30px;
  }
}
.productselection-header2 {
  margin-bottom: 30px;
}

h4 {
  font: 18px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  margin-bottom: 10px;
}
@media (max-width: 1024px) {
  h4 {
    font: 16px;
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-top: -15px !important;
    margin-left: 46px !important;
    margin-bottom: 6px !important;
  }
}

#abmHeading {
  top: 701px;
  left: 274px;
  width: 290px;
  height: 29px;
  margin-left: 130px;
  text-align: center;
  font-family: normal normal medium 22px/21px ATT Aleck Sans !important;
  font-size: 22px;
  letter-spacing: 0.18px;
  color: #000000;
  opacity: 1;
}
@media (max-width: 1024px) {
  #abmHeading {
    width: 242px;
    height: 32px;
    margin-left: 20px;
    font-size: 18px;
  }
}

.innerCont {
  padding: 0px 50px 0px 0px;
  font-weight: 700;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .innerCont {
    padding: 0px 20px 0px 20px;
  }
}

.innerCont-qsn {
  padding: 5px 50px 0px 0px;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .innerCont-qsn {
    padding: 0px 20px 0px 20px;
  }
}

.addSpace1 {
  padding-top: 5px;
}
@media (max-width: 1024px) {
  .addSpace1 {
    margin: 10px 0px;
    word-wrap: break-word;
    max-width: 395px;
    margin-left: -27px;
  }
}
@media only screen and (max-width: 1020px) and (min-width: 400px) {
  .addSpace1 {
    max-width: 325px;
    margin-left: -30px;
  }
}

.addSpace {
  margin: 0px 0px 0px 0px;
}
@media (max-width: 1024px) {
  .addSpace {
    margin: 0px 0px 0px 0px;
  }
}

.blueLine {
  padding-top: 20px;
}

@media only screen and (max-width: 1020px) {
  .blueLine {
    padding-top: 0px;
  }
}
.product-selection-container {
  margin: 0 16.66%;
}
.product-selection-container h1 {
  padding-left: 5px;
}
@media (max-width: 1024px) {
  .product-selection-container h1 {
    margin-left: -35px;
    font-size: 28px;
    margin-top: 35px;
  }
}
.product-selection-container .live {
  padding: 10px 0px 0px 0px;
}
.product-selection-container .subLabel,
.product-selection-container input[type=text] {
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  color: #191919;
  font-size: 16px;
  width: 560px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border: 1px solid #D1D2D3 !important;
  border-radius: 5px !important;
}
@media (max-width: 1024px) {
  .product-selection-container .subLabel,
  .product-selection-container input[type=text] {
    width: 280px;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .product-selection-container .subLabel,
  .product-selection-container input[type=text] {
    width: 370px;
  }
}
@media only screen and (max-width: 1050px) and (min-width: 750px) {
  .product-selection-container .subLabel,
  .product-selection-container input[type=text] {
    width: 285px;
  }
}
.product-selection-container .article {
  padding: 3px;
  margin-left: 15px;
}
.product-selection-container .subHeader {
  font-size: 22px;
}
.product-selection-container .error-container .message {
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  font-size: 14px;
  padding: 3px 0;
}
.product-selection-container .googleId, .product-selection-container .samsungId, .product-selection-container .appleId {
  padding: 20px 0px 0px 0px;
  display: none;
}
.product-selection-container .tooltip-container i.tooltip-icon {
  display: none;
}
.product-selection-container .form-control {
  width: 552px;
}
@media (max-width: 1024px) {
  .product-selection-container .form-control {
    width: 235px;
  }
}
.product-selection-container .gtooltip, .product-selection-container .stooltip {
  bottom: 29px;
  left: 350px !important;
}
@media (max-width: 1024px) {
  .product-selection-container .gtooltip, .product-selection-container .stooltip {
    bottom: 30px;
    left: 260px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .product-selection-container .gtooltip, .product-selection-container .stooltip {
    bottom: 0px;
    left: -30px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .product-selection-container i.tooltip-icon::after {
    margin-top: -10px;
  }
}
.product-selection-container .helper-text {
  top: 0px;
}
@media (max-width: 1024px) {
  .product-selection-container .helper-text {
    left: 0px;
    top: 33px;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .product-selection-container .helper-text {
    top: 37px;
  }
}
.product-selection-container #samsung-name-error, .product-selection-container #google-name-error, .product-selection-container #google-name-error1, .product-selection-container #google-name-error2, .product-selection-container #google-name-error3, .product-selection-container #google-name-error4 {
  margin-top: -10px;
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .product-selection-container #samsung-name-error, .product-selection-container #google-name-error, .product-selection-container #google-name-error1, .product-selection-container #google-name-error2, .product-selection-container #google-name-error3, .product-selection-container #google-name-error4 {
    margin-top: 5px;
  }
}
.product-selection-container .changeNonIBM, .product-selection-container .changeIBM {
  border: 1px solid grey;
  border-radius: 15px;
  padding: 15px 15px 5px 15px;
  margin: 20px 0px 20px 0px;
  display: none;
}
.product-selection-container .selectedDetails, .product-selection-container .selectedDetailsKme {
  padding: 20px 0px 20px 35px;
  display: none;
}
.product-selection-container .product-brief-link-kme, .product-selection-container .product-brief-link-ztp {
  margin-left: 5px;
}

.radio input + .skin {
  border-radius: 100%;
}

.box1 {
  top: 549px;
  left: 421px;
  width: 38px;
  height: 7px;
  background: #61CFFB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: -22px;
  margin-top: 46px;
}
@media (max-width: 1024px) {
  .box1 {
    width: 90px;
    margin-left: -23px;
    margin-top: 30px;
  }
}

.box2 {
  top: 549px;
  left: 450px;
  width: 39px;
  height: 7px;
  background: #52B6EB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 5px;
  margin-top: -7px;
}
@media (max-width: 1024px) {
  .box2 {
    width: 90px;
    margin-left: 18px;
  }
}

.box3 {
  top: 549px;
  left: 480px;
  width: 39px;
  height: 7px;
  background: #3E9DD6 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 35px;
  margin-top: -7px;
}
@media (max-width: 1024px) {
  .box3 {
    width: 90px;
    margin-left: 68px;
  }
}

.box4 {
  top: 549px;
  left: 509px;
  width: 39px;
  height: 7px;
  background: #3386C5 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 65px;
  margin-top: -7px;
}
@media (max-width: 1024px) {
  .box4 {
    width: 90px;
    margin-left: 116px;
  }
}

.box5 {
  top: 549px;
  left: 539px;
  width: 39px;
  height: 7px;
  background: #286EB8 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 95px;
  margin-top: -7px;
}
@media (max-width: 1024px) {
  .box5 {
    width: 90px;
    margin-left: 165px;
  }
}

.box6 {
  top: 549px;
  left: 569px;
  width: 37px;
  height: 7px;
  background: #1F56A9 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 127px;
  margin-top: -7px;
}
@media (max-width: 1024px) {
  .box6 {
    width: 90px;
    margin-left: 213px;
  }
}

.efota-section .efota-paragraph {
  margin-bottom: 0px;
}
.efota-section .efota-link {
  cursor: pointer;
}
.efota-section .efota-link:hover {
  text-decoration: underline;
}
@media (max-width: 1024px) {
  .efota-section {
    width: 325px;
    margin-left: -45px;
  }
}

.loginModal {
  padding-left: 3px;
}
.loginModal .btn-secondary {
  width: 324px;
}

.model-box-loginModal {
  border-radius: 8px;
  animation: animatetop 0.4s;
  background: white;
  margin: 0 auto;
  max-height: 80%;
  max-width: 620px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  top: 35%;
  padding: 15px;
  width: 348px;
  text-align: center;
  font-weight: 700;
}

.model-cover .model-box-loginModal {
  background: 0 3px 8px 3px rgba(255, 255, 255, 0) !important;
}

.model-cover {
  background: 0 3px 8px 3px rgba(255, 255, 255, 0) !important;
}

.model-box {
  box-shadow: none !important;
}

.spinner {
  width: 100%;
  margin-bottom: 5px;
}

.spinner img {
  align-items: center;
  width: 35px;
}

.loading-text {
  display: inline-grid;
}

.content-text i.tooltip-icon.tooltipActive:after {
  margin-top: 32px;
}

.valign-children-middle p {
  padding: 10px;
}

.mr-5 {
  margin-top: 5px !important;
  margin-bottom: 5px;
}

.mr-10 {
  margin-top: 10px;
}

.mr-17 {
  margin-top: 17px;
}

.mr-25 {
  margin-top: 25px;
}

.mr-30 {
  margin-top: 30px;
}

.mr-40 {
  margin-top: 40px;
}

.mb-10 {
  margin-bottom: 10px;
}

.pointer-sym {
  cursor: pointer;
}

.disabledDiv {
  opacity: 0.3;
}

.google-ztp-icon, .apple-abm-icon {
  width: 100px;
}

.sub-content {
  font-size: 14px;
  font-weight: 400 !important;
  text-align: center;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.tile-heading {
  width: 160px;
}

.progress-bar {
  width: 598px;
  margin-left: 3px;
}
@media (max-width: 1024px) {
  .progress-bar {
    width: 323px;
    margin-left: -22px;
  }
}

.progress-steps {
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
}

.progress-steps .step1 {
  padding: 10px 20px;
  border-bottom: 3px solid #D2D2D2;
  font-size: 14px;
  flex: 1;
  width: 186px;
  padding-left: 0px;
}
@media (max-width: 1024px) {
  .progress-steps .step1 {
    width: 107px;
  }
}

.progressBar-highlight {
  border-bottom: 3px solid var(--ATT-Blue, #009FDB) !important;
}

.stepper-text {
  color: var(--ATT-Blue, #009FDB);
}

.progress-steps .step2 {
  padding: 10px 20px;
  border-bottom: 3px solid #D2D2D2;
  margin-left: 5px;
  font-size: 14px;
  flex: 1;
  width: 186px;
  padding-left: 0px;
}
@media (max-width: 1024px) {
  .progress-steps .step2 {
    width: 107px;
  }
}

@media (max-width: 1024px) {
  .step2 span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.progress-steps .step3 {
  padding: 10px 20px;
  border-bottom: 3px solid #D2D2D2;
  margin-left: 5px;
  font-size: 14px;
  flex: 1;
  width: 186px;
  padding-left: 0px;
}
@media (max-width: 1024px) {
  .progress-steps .step3 {
    width: 107px;
  }
}

.radio-group {
  display: flex;
  gap: 40px;
  align-items: center;
  padding-left: 45px;
  margin-top: -6px;
}
@media (max-width: 1024px) {
  .radio-group {
    flex-direction: column;
    gap: 15px;
    padding-left: 20px;
    align-items: flex-start !important;
  }
}

.option-label {
  margin-left: 28px;
  font-family: ATT Aleck Sans;
  font-size: 14px;
}

.continue-btn {
  border-radius: 42px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--Controls-Button-Primary-Fill, #00388F);
  font-size: 15px;
}
@media (max-width: 1024px) {
  .continue-btn {
    width: 100px !important;
    margin-right: 10px !important;
  }
}

.align-button {
  padding-top: 12px;
  padding-right: 0px;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 35px;
}
@media (max-width: 1024px) {
  .button-container {
    gap: 25px;
    margin-top: 25px;
  }
}

.home-btn {
  min-width: 100px;
  height: 32px;
  opacity: 1;
  gap: 10px;
  font-size: 15px;
  border-radius: 48px;
  border-width: 2px;
  padding-top: 8px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);
  background: var(--Controls-Button-Primary-Fill, #00388F);
  color: var(--Controls-Button-Secondary-Text-icon, #e8ebf0);
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1024px) {
  .home-btn {
    font-size: 15px;
    width: 133px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.back-btn {
  min-width: 100px;
  height: 32px;
  opacity: 1;
  gap: 10px;
  border-radius: 48px;
  border-width: 2px;
  padding-top: 8px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);
  background: #F1F2F3 0% 0% no-repeat padding-box !important;
  color: var(--Controls-Button-Secondary-Text-icon, #00388F);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.tooltip-div {
  right: 452px !important;
}

.tooltip-text {
  padding: 10px;
  display: inline-block;
  position: absolute;
  width: 279px;
  font-size: 11px;
  border-radius: 7px;
  background-color: white;
  border: 1px solid var(--Controls-Border-Floating, #DCDFE3);
  box-shadow: 0px 2px 12px 0px rgba(80, 127, 171, 0.059);
  box-shadow: 0px 2px 4px -1px rgba(37, 48, 58, 0.0588235294);
  box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);
}
@media (max-width: 1024px) {
  .tooltip-text {
    top: -151px !important;
    left: 125px;
  }
}

.copy-icon {
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  cursor: pointer;
  width: 42px;
}
@media (max-width: 1024px) {
  .copy-icon {
    margin-left: 21%;
  }
}

.reseller-id {
  margin-top: 6px;
  margin-left: 8px;
}

.copied-message {
  color: var(--Controls-Button-Secondary-Text-icon, #00388F);
  font-size: 1rem;
  margin-left: 10px;
  font-weight: bold;
}

.orgId-field {
  margin-left: 35px;
}
@media (max-width: 1024px) {
  .orgId-field {
    margin-left: 20px;
    margin-bottom: 20px;
  }
}

.input-field {
  width: 470px !important;
}

h6 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.account-info {
  width: 100%;
  max-width: 400px;
  margin-left: 30px;
  table-layout: fixed;
}

.account-info td {
  padding: 0px;
  border-color: transparent;
}

.mob-email {
  max-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.tableData {
  padding-right: 50px !important;
}

@media (max-width: 1024px) {
  .abmAcc-info {
    margin-left: 0px;
  }
}

@media (max-width: 1024px) {
  .abmAcc-info td {
    width: 76px;
  }
}

.heading-1 {
  font-size: 15px;
  font-weight: bold;
  margin-left: 30px;
  margin-bottom: 13px !important;
}

.ABMheading {
  font-size: 15px;
  font-weight: bold;
  margin-left: 30px;
  margin-bottom: 13px !important;
}
@media (max-width: 1024px) {
  .ABMheading {
    margin-left: 0px;
  }
}

.step {
  margin-bottom: 15px;
}

.fan-selection-page {
  margin-top: 0px !important;
  margin-left: 15px;
}

@media screen and (min-width: 768px) {
  router-outlet[name=mobile-view] {
    display: none;
  }
}
/* Hide desktop outlet on mobile */
@media screen and (max-width: 767px) {
  router-outlet[name=desktop-desktop] {
    display: none;
  }
}
.content-spacing {
  margin-top: 20px;
  padding-bottom: 10px;
}

.orgId-input {
  top: 693px;
  left: 437px;
  width: 470px !important;
  height: 36px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border-radius: 7px !important;
  margin-bottom: 20px !important;
}
@media (max-width: 1024px) {
  .orgId-input {
    width: 280px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .orgId-input {
    width: 280px !important;
  }
}

.paragraph-spacing {
  margin-bottom: 5px !important;
  margin-top: 20px;
}

.model-cover {
  background: rgba(0, 0, 0, 0.7);
}

.model-box-loginModal {
  border-radius: 8px;
  animation: animatetop 0.4s;
  background: white;
  margin: 0 auto;
  max-height: 92%;
  max-width: 620px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  top: 2%;
  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);
  padding: 20px 32px 32px 32px;
  width: 360px;
}
@media (max-width: 1024px) {
  .model-box-loginModal {
    top: 10%;
  }
}

.modal-header-loginModal {
  padding: 0px !important;
  position: relative;
}

.modalHeading {
  color: #3A6EB2;
  text-align: center;
  margin-bottom: 13px;
  font-family: ATT Aleck Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 36px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0.75px;
}

.confirm-msg {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 100;
  text-align: left;
}

.confirmation-span {
  text-align: center;
  margin-bottom: 14px;
}

.understand-btn {
  font-size: 15px;
  height: 35px;
  display: inline-block;
  justify-content: center;
  align-items: center;
}

.continue-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: 8px;
}

.center-button {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 42px;
  background: var(--Controls-Button-Primary-Fill, #00388F);
}

.cancel-link {
  text-decoration: underline;
  cursor: pointer;
}

.new-tooltip-input {
  right: -500px;
  bottom: -10px;
  width: 32px;
}

.tooltip-new {
  font-size: 17px !important;
  color: var(--Controls-Tooltip-icon, #454B52) !important;
  top: 438px !important;
  margin-right: 310px;
}
@media (max-width: 1024px) {
  .tooltip-new {
    top: 352px !important;
    margin-right: 82px;
  }
}

.tooltip-content {
  width: 300;
  height: 67.0001296997;
  angle: 0 deg;
  opacity: 1;
  border-width: 1px;
  border-radius: 4px;
  color: black;
  top: 425px !important;
  background-color: white;
  background: var(--Controls-Fill, #FFFFFF);
}

.appleValue-error {
  padding-bottom: 10px;
}

i.tooltip-icon.tooltipActive:after {
  background-color: var(--Controls-Fill, #FFFFFF);
  top: -17px;
  right: 0px;
}

.radio-btn {
  margin-top: 20px !important;
}

.align-tooltip {
  display: inline-flex;
  align-items: center;
}
.align-tooltip p {
  margin: 0;
  padding: 0;
  display: inline;
  line-height: 1.5;
}
@media (max-width: 1024px) {
  .align-tooltip .tooltip-abm {
    margin-top: 10% !important;
    left: -22% !important;
  }
}
.align-tooltip .tooltip-icon {
  margin: 0;
  padding: 0;
  vertical-align: middle;
  right: 40%;
  top: 9px !important;
}
@media (max-width: 1024px) {
  .align-tooltip .tooltip-icon {
    right: 3%;
    top: 19px !important;
  }
}
.align-tooltip .tooltip-icon-kme {
  right: 80%;
}

.tooltip-new-zte {
  font-size: 17px !important;
  color: var(--Controls-Tooltip-icon, #454B52) !important;
  position: relative !important;
}
@media (max-width: 1024px) {
  .tooltip-new-zte {
    top: 176px !important;
    margin-right: 45px;
  }
}

@media (max-width: 1024px) {
  .tooltip-text-zte {
    left: 147px !important;
    top: -325px !important;
    color: black;
  }
}

.tooltip-new-kme {
  font-size: 17px !important;
  color: var(--Controls-Tooltip-icon, #454B52) !important;
  top: 439px !important;
  margin-right: 550px;
}
@media (max-width: 1024px) {
  .tooltip-new-kme {
    top: 198px !important;
    margin-right: 130px;
  }
}

.tooltip-text-kme {
  left: 250px !important;
  top: 328px !important;
  color: black;
}
@media (max-width: 1024px) {
  .tooltip-text-kme {
    left: 72px !important;
    top: -306px !important;
  }
}

.form-input {
  width: 470px !important;
  padding-left: 10px;
}
@media (max-width: 1024px) {
  .form-input {
    width: 240px !important;
  }
}

.orgId-input-zte {
  top: 693px;
  left: 437px;
  width: 470px !important;
  height: 36px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
  border-radius: 7px !important;
}
@media (max-width: 1024px) {
  .orgId-input-zte {
    width: 240px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 920px) {
  .orgId-input-zte {
    width: 240px !important;
  }
}

.google-input {
  width: 455px !important;
}
@media (max-width: 1024px) {
  .google-input {
    width: 240px !important;
  }
}

.google-field {
  width: 455px !important;
}
@media (max-width: 1024px) {
  .google-field {
    width: 240px !important;
  }
}

.field-section {
  margin-left: 35px;
}
@media (max-width: 1024px) {
  .field-section {
    margin-left: 0px !important;
  }
}

@media (max-width: 1024px) {
  .acc-info {
    width: 255px !important;
  }
}

.p-spacing {
  margin-top: 20px !important;
}

.content-info {
  padding: 0px !important;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .content-info {
    margin-top: 0px !important;
  }
}

.content-infoqsn {
  padding: 0px !important;
  margin-top: 10px;
}

.kme-content {
  margin-top: -7px !important;
}

.zte-heading {
  margin-left: 27px;
}

.googleAccount {
  margin-top: 15px !important;
}

.orgInfo {
  margin-left: 6px !important;
}

.tooltip-text-disable {
  width: 200px;
  display: none;
  position: absolute;
  border-color: #333;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-left: -60px;
  font-size: 12px;
  z-index: 9999999;
  pointer-events: none;
  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.059);
}

.inputField-name {
  margin: 20px 0 5px 0;
}

.error-msg {
  margin: 14px 0 10px 38px !important;
  padding-right: 30px;
}

.error1-msg {
  margin: -10px 0 10px 36px !important;
}

@media (max-width: 1024px) {
  .err-msg {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
}

@media (max-width: 1024px) {
  .err1-msg {
    margin-left: 25px;
    margin-top: -4px !important;
    margin-bottom: 10px !important;
  }
}

.kme-p {
  margin-top: -10px !important;
}

.kme-field {
  margin-top: -17px;
}

.kmeContent {
  margin-top: 0px !important;
}

.back-btn:focus,
.continue-btn:focus,
.understand-btn:focus {
  outline: 1px dotted #00388F;
  outline-offset: 2px !important;
}

.continue-btn:focus-visible,
.back-btn:focus-visible,
.home-btn:focus-visible,
.center-button:focus-visible,
.understand-btn:focus-visible {
  box-shadow: 0 0 0 2px #00388F;
}

.orgId-input:focus-visible,
.orgId-input-zte:focus-visible,
.field:focus-visible,
.form-input:focus-visible,
.google-input:focus-visible,
.google-field:focus-visible,
.product-selection-container input[type=text]:focus-visible {
  border-color: #00388F;
  box-shadow: 0 0 0 1px #00388F;
}

.radio-group input[type=radio]:focus-visible + .skin,
.radio-btn input[type=radio]:focus-visible + .skin,
.radio-button input[type=radio]:focus-visible + .skin {
  border-color: #00388F;
  box-shadow: 0 0 0 2px #00388F;
}

.product-selection-page a:focus-visible,
.product-selection-container a:focus-visible,
.cancel-link:focus-visible {
  box-shadow: 0 0 0 2px #00388F;
}

.copy-icon:focus-visible {
  box-shadow: 0 0 0 2px #00388F;
}

.alert-warning {
  background-color: orange;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/product-selection/product-selection.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,mBAAA;EACA,8DAAA;AAkJF;AF/HI;EErBJ;IAII,kBAAA;EAoJF;AACF;AAnJE;EACE,iBAAA;AAqJJ;AFvII;EEfF;IAGI,kBAAA;EAuJJ;AACF;AAtJI;EALF;IAMI,kBAAA;EAyJJ;AACF;AFjJI;EEIF;IAEE,YAAA;IACA,YAAA;IACA,mBAAA;EA+IF;AACF;AA9II;EANF;IAOI,mBAAA;EAiJJ;AACF;AA/IE;EACE;IAAO,kBAAA;IACP,mBAAA;IACA,kBAAA;EAkJF;EAjJE;IACE,0BAAA;EAmJJ;EAjJC;IACC,WAAA;IACA,SAAA;EAmJF;AACF;AA3IE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA6IJ;AFlLI;EEgCF;IAOI,aAAA;IACF,YAAA;IACA,kBAAA;IACA,iBAAA;EA+IF;AACF;AA7IE;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AA+IJ;AFnMI;EE6CF;IAUI,kBAAA;IACA,sBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EAgJJ;AACF;AA9IE;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAgJJ;AFjNI;EE8DF;IAKI,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAkJJ;AACF;AAhJE;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAkJJ;AF9NI;EEyEF;IAKI,YAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAoJJ;AACF;AAlJE;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAoJJ;AF3OI;EEoFF;IAKI,YAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAsJJ;AACF;AApJE;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAsJJ;AFxPI;EE+FF;IAKI,YAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAwJJ;AACF;AArJE;EACE,eAAA;EACA,0BAAA;AAuJJ;AApJE;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EAGA,kBAAA;EACA,uBAAA;EACA,0DAAA;EACA,sDAAA;EACA,2DAAA;EACA,0DAAA;EACA,qBAAA;EACA,YAAA;EAEA,mBAAA;EAGA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAiJJ;AFzRI;EEgHF;IA0BM,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;EAmJN;AACF;AAjJI;EAjCF;IAkCI,UAAA;IAEA,eAAA;EAmJJ;AACF;AA9IA;EACI,YAAA;EACA,WAAA;EACA,WAAA;AAgJJ;AF7SI;EE0JJ;IAMQ,aAAA;IACA,YAAA;IACA,WAAA;EAiJN;AACF;AA9IE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAgJJ;AF3TI;EEsKF;IAQI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EAiJJ;AACF;AA9IE;EACE,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;AAgJJ;AF7UI;EEqLF;IAUI,sBAAA;IACA,4BAAA;IACA,aAAA;EAkJJ;AACF;AA/IE;EACE,iBAAA;AAiJJ;AA9IE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAgJJ;AFlWI;EEyMF;IAWI,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,iBAAA;EAkJJ;AACF;AA/II;EACE,UAAA;EACA,gBAAA;EACA,8DAAA;AAiJN;AA/II;EACE,qBAAA;AAiJN;AA/II;EACE,qBAAA;AAiJN;AA/II;EACE,kBAAA;AAiJN;AFzXI;EErBJ;IAkQI,mBAAA;IACA,iBAAA;EAgJF;AACF;;AA7IA;EACE,6CAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAgJF;;AA7IA;EACE,iBAAA;EACA,iBAAA;AAgJF;AF7YI;EE2PJ;IAKI,kBAAA;IACA,iBAAA;EAiJF;AACF;;AA9IA;EACE,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAiJF;AF/ZI;EEqQJ;IAYI,WAAA;IAEA,kBAAA;IACA,sBAAA;EAiJF;AACF;AAhJE;EAjBF;IAmBI,kBAAA;EAkJF;AACF;;AA/IA;EACE,YAAA;AAkJF;;AA1IE;EALF;IAOI,gBAAA;EA6IF;AACF;;AA1IA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EAEA,+CAAA;EACA,yBAAA;EAEA,UAAA;EACA,8DAAA;AA2IF;AFjcI;EE2SJ;IAgBI,YAAA;IACA,aAAA;EA0IF;AACF;;AFvcI;EEmUF;IAEE,kBAAA;EAuIF;AACF;AAhIA;EACE,iEAAA;EACA,mBAAA;AAkIF;;AA/HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EAEA,+CAAA;EACA,yBAAA;EAEA,UAAA;EACA,8DAAA;AAgIF;AF9dI;EEkVJ;IAeI,8DAAA;IACA,iBAAA;IACA,YAAA;IACA,aAAA;EAiIF;AACF;;AA9HA;EACE,iEAAA;EACA,mBAAA;AAiIF;;AA9HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EAEA,+CAAA;EACA,yBAAA;EAEA,UAAA;EACA,8DAAA;AA+HF;AFxfI;EE6WJ;IAeI,8DAAA;IACA,iBAAA;IACA,YAAA;IACA,aAAA;EAgIF;AACF;;AA7HA;EACE,iEAAA;EACA,mBAAA;AAgIF;;AA7HA;EACE,gBAAA;EACA,4BAAA;AAgIF;AA1HA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8DAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AA4HF;AFvhBI;EEgZJ;IAaE,kBAAA;EA8HA;AACF;;AA3HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8DAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AA8HF;AA5HE;EACE,6BAAA;AA8HJ;AF5iBI;EEiaJ;IAgBI,YAAA;IACA,iBAAA;EA+HF;AACF;;AA5HA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AA+HF;AF1jBI;EEsbJ;IAQI,gBAAA;IACA,iBAAA;EAgIF;AACF;;AA5HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EAEA,+CAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,8DAAA;AA8HF;AA5HE;EACE,8BAAA;EACA,eAAA;AA8HJ;AFllBI;EEocJ;IAmBI,8DAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;IAEA,eAAA;EA8HF;EA7HE;IACE,mBAAA;IACA,gBAAA;EA+HJ;AACF;AA9HI;EA7BJ;IA+BI,YAAA;EAgIF;AACF;;AA5HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EAEA,+CAAA;EACA,UAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EAEA,8DAAA;AA6HF;AA3HE;EACE,kBAAA;AA6HJ;AFnnBI;EEweJ;IAiBI,8DAAA;IACA,gBAAA;IACA,YAAA;EA8HF;EA3HE;IACE,kBAAA;EA6HJ;AACF;AA3HE;EA1BF;IA4BI,uBAAA;EA6HF;AACF;AA5HE;EA9BF;IAgCI,YAAA;EA8HF;AACF;;AA3HA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,8DAAA;AA8HF;AA5HE;EACE,mBAAA;EACA,eAAA;AA8HJ;AFvpBI;EE4gBJ;IAgBI,8DAAA;IACA,gBAAA;IACA,YAAA;EA+HF;EA5HE;IACE,kBAAA;EA8HJ;AACF;AA5HE;EAzBF;IA2BI,uBAAA;EA8HF;AACF;AA7HE;EA7BF;IA+BI,YAAA;EA+HF;AACF;;AA5HA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0DAAA;EACA,8DAAA;EAEA,6BAAA;AA8HF;AFrrBI;EE+iBJ;IAYI,uBAAA;EA8HF;AACF;AA7HE;EAdF;IAgBO,uBAAA;EA+HL;AACF;;AA5HA;EACE,YAAA;AA+HF;;AA5HA;EACE,gBAAA;EACA,8DAAA;AA+HF;;AA7HA;EACE,gBAAA;EACA,mBAAA;AAgIF;AF7sBI;EE2kBJ;IAII,YAAA;IACA,6BAAA;EAkIF;AACF;AAlII;EANJ;IAQI,YAAA;IACA,6BAAA;EAoIF;AACF;;AAlIA;EACE,UAAA;EACA,8DAAA;EACA,gBAAA;EACA,mBAAA;AAqIF;AFhuBI;EEulBJ;IAMI,UAAA;IACA,8DAAA;EAuIF;AACF;;AArIA;EACE,qBAAA;EACA,8DAAA;EACA,mBAAA;AAwIF;AF5uBI;EEimBJ;IAKI,0BAAA;IACA,8DAAA;EA0IF;AACF;;AAxIA;EACE,mBAAA;EACA,qDAAA;EACA,0BAAA;AA2IF;AFxvBI;EE0mBJ;IAKI,YAAA;IACA,kBAAA;EA6IF;AACF;AAvIA;EACE,mBAAA;AAyIF;;AAvIA;EACE,UAAA;EACA,8DAAA;EACA,mBAAA;AA0IF;AFvwBI;EE0nBJ;IAKI,UAAA;IACA,8DAAA;IACA,4BAAA;IACA,4BAAA;IACA,6BAAA;EA4IF;AACF;;AAzIA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qEAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AA4IF;AF9xBI;EEuoBJ;IAaI,YAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EA8IF;AACF;;AA3IA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;AA8IF;AF5yBI;EE2pBJ;IAKI,0BAAA;EAgJF;AACF;;AA7IA;EACE,yBAAA;EACA,eAAA;AAgJF;AFtzBI;EEoqBJ;IAII,0BAAA;EAkJF;AACF;;AA/IA;EACE,gBAAA;AAkJF;AF/zBI;EE4qBJ;IAGI,gBAAA;IACA,qBAAA;IACA,gBAAA;IACA,kBAAA;EAoJF;AACF;AAnJE;EARF;IAUI,gBAAA;IACA,kBAAA;EAqJF;AACF;;AAlJA;EACE,uBAAA;AAqJF;AFj1BI;EE2rBJ;IAGI,uBAAA;EAuJF;AACF;;AApJA;EACE,iBAAA;AAuJF;;AArJA;EACE;IACA,gBAAA;EAwJA;AACF;AArJA;EAcE,gBAAA;AA0IF;AAtJE;EACE,iBAAA;AAwJJ;AFt2BI;EE6sBF;IAGI,kBAAA;IACA,eAAA;IACA,gBAAA;EA0JJ;AACF;AA5IE;EACE,yBAAA;AA8IJ;AA3IE;;EAEE,8DAAA;EACA,cAAA;EACA,eAAA;EAEA,YAAA;EACA,0DAAA;EACA,8DAAA;EACA,oCAAA;EACA,6BAAA;AA4IJ;AF33BI;EEquBF;;IAaI,YAAA;EA8IJ;AACF;AA7II;EAfF;;IAiBK,YAAA;EAgJL;AACF;AA/IK;EAnBH;;IAqBK,YAAA;EAkJL;AACF;AA/IE;EACE,YAAA;EACA,iBAAA;AAiJJ;AA9IE;EACE,eAAA;AAgJJ;AA7II;EACE,8DAAA;EACA,eAAA;EACA,cAAA;AA+IN;AA5IE;EACE,yBAAA;EACA,aAAA;AA8IJ;AA3IE;EACE,aAAA;AA6IJ;AA1IE;EACE,YAAA;AA4IJ;AFn6BI;EEsxBF;IAGI,YAAA;EA8IJ;AACF;AA3IE;EACE,YAAA;EACA,sBAAA;AA6IJ;AF56BI;EE6xBF;IAII,YAAA;IACA,sBAAA;EA+IJ;AACF;AA9II;EAPF;IAQI,WAAA;IACA,sBAAA;EAiJJ;AACF;AA7II;EADF;IAEI,iBAAA;EAgJJ;AACF;AA9IE;EAEE,QAAA;AA+IJ;AFh8BI;EE+yBF;IAII,SAAA;IACA,SAAA;EAiJJ;AACF;AAhJG;EAPD;IASI,SAAA;EAkJJ;AACF;AA/IE;EACE,iBAAA;AAiJJ;AAhJI;EAFF;IAGI,eAAA;EAmJJ;AACF;AAhJE;EACE,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,aAAA;AAkJJ;AAhJE;EACE,2BAAA;EAEA,aAAA;AAiJJ;AA/IE;EACE,gBAAA;AAiJJ;;AA5IA;EACE,mBAAA;AA+IF;;AA5IA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AA+IF;AFh/BI;EEy1BJ;IAUI,WAAA;IACA,kBAAA;IACA,gBAAA;EAiJF;AACF;;AA7IA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAgJF;AFlgCI;EE02BJ;IAUI,WAAA;IACA,iBAAA;EAkJF;AACF;;AA/IA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAkJF;AFnhCI;EEy3BJ;IAUI,WAAA;IACA,iBAAA;EAoJF;AACF;;AAjJA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAoJF;AFpiCI;EEw4BJ;IAUI,WAAA;IACA,kBAAA;EAsJF;AACF;;AAnJA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAsJF;AFrjCI;EEu5BJ;IAUI,WAAA;IACA,kBAAA;EAwJF;AACF;;AArJA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AAwJF;AFtkCI;EEs6BJ;IAUI,WAAA;IACA,kBAAA;EA0JF;AACF;;AAtJE;EACE,kBAAA;AAyJJ;AAvJE;EACE,eAAA;AAyJJ;AAvJE;EACE,0BAAA;AAyJJ;AFtlCI;EEq7BJ;IAWI,YAAA;IACA,kBAAA;EA0JF;AACF;;AArJA;EACI,iBAAA;AAwJJ;AAvJE;EACE,YAAA;AAyJJ;;AArJA;EACI,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EAGA,aAAA;EACA,YAAA;EAEA,kBAAA;EACA,gBAAA;AAqJJ;;AAlJA;EACE,2DAAA;AAqJF;;AAlJA;EACE,2DAAA;AAqJF;;AAlJA;EACE,2BAAA;AAqJF;;AAlJA;EACE,WAAA;EACA,kBAAA;AAqJF;;AAnJA;EACE,mBAAA;EACA,WAAA;AAsJF;;AAnJA;EACE,oBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,aAAA;AAsJF;;AAnJA;EACE,0BAAA;EACA,kBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,gBAAA;AAsJF;;AAnJA;EACE,mBAAA;AAsJF;;AAnJA;EACE,eAAA;AAsJF;;AAnJA;EAEE,YAAA;AAqJF;;AAlJA;EACE,YAAA;AAqJF;;AAjJA;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AAoJF;;AAhJA;EACE,YAAA;AAmJF;;AAhJA;EAIE,YAAA;EACA,gBAAA;AAgJF;AFntCI;EE8jCJ;IAOI,YAAA;IACA,kBAAA;EAkJF;AACF;;AA/IA;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AAkJF;;AAzIA;EACE,kBAAA;EACA,gCAAA;EAEA,eAAA;EAEA,OAAA;EACA,YAAA;EACA,iBAAA;AA0IF;AFzuCI;EEulCJ;IAUI,YAAA;EA4IF;AACF;;AAzIA;EACE,4DAAA;AA4IF;;AA1IA;EACE,+BAAA;AA6IF;;AA1IA;EACE,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EAEA,OAAA;EACA,YAAA;EACA,iBAAA;AA4IF;AFhwCI;EE4mCJ;IAUI,YAAA;EA8IF;AACF;;AFrwCI;EE2nCJ;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;EA8IA;AACF;AA3IA;EACE,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;AA6IF;AFtxCI;EEkoCJ;IASI,YAAA;EA+IF;AACF;;AA5IA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA+IF;AFnyCI;EE+oCJ;IAOI,sBAAA;IACA,SAAA;IACA,kBAAA;IACA,kCAAA;EAiJF;AACF;;AA9IA;EACE,iBAAA;EACA,2BAAA;EACA,eAAA;AAiJF;;AA9IA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wDAAA;EACA,eAAA;AAiJF;AF3zCI;EEmqCJ;IASI,uBAAA;IACA,6BAAA;EAmJF;AACF;;AAhJA;EACE,iBAAA;EACA,kBAAA;AAmJF;AA7IA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA+IF;AF50CI;EEyrCJ;IAMI,SAAA;IACA,gBAAA;EAiJF;AACF;;AA9IA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kEAAA;EACA,wDAAA;EACA,0DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAiJF;AFt2CI;EEosCJ;IAmBI,eAAA;IACA,YAAA;IACA,iBAAA;IACA,oBAAA;EAmJF;AACF;;AA/IA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kEAAA;EACA,0DAAA;EACA,0DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAkJF;;AAzIA;EACE,uBAAA;AA4IF;;AAzIA;EACE,aAAA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAGA,kBAAA;EACA,uBAAA;EACA,0DAAA;EACA,sDAAA;EACA,2DAAA;EACA,0DAAA;AA0IJ;AFp5CI;EE6vCJ;IAeM,sBAAA;IACA,WAAA;EA4IJ;AACF;;AAzIA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AA4IF;AFp6CI;EEixCJ;IASM,gBAAA;EA8IJ;AACF;;AA3IA;EACE,eAAA;EACA,gBAAA;AA8IF;;AA3IA;EACE,0DAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA8IF;;AAnIA;EACE,iBAAA;AAsIF;AFz7CI;EEkzCJ;IAGI,iBAAA;IACA,mBAAA;EAwIF;AACF;;AArIA;EACE,uBAAA;AAwIF;;AArIA;EACE,eAAA;EACA,kBAAA;AAwIF;;AA/HA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAkIF;;AA/HA;EACE,YAAA;EACA,yBAAA;AAkIF;;AA/HA;EACE,YAAA;EACA,uBAAA;EACA,sBAAA;AAkIF;;AA/HA;EACE,8BAAA;AAkIF;;AF99CI;EE+1CJ;IAEI,gBAAA;EAkIF;AACF;;AFp+CI;EEq2CJ;IAEE,WAAA;EAkIA;AACF;;AA/HA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AAkIF;;AA/HA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AAkIF;AFx/CI;EEk3CJ;IAMI,gBAAA;EAoIF;AACF;;AAjIA;EACE,mBAAA;AAoIF;;AAjIA;EACE,0BAAA;EACA,iBAAA;AAoIF;;AAjIA;EACE;IACE,aAAA;EAoIF;AACF;AAjIA,kCAAA;AACA;EACE;IACE,aAAA;EAmIF;AACF;AAjIA;EACE,gBAAA;EACA,oBAAA;AAmIF;;AAhIA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0DAAA;EACA,8DAAA;EACA,6BAAA;EACA,8BAAA;AAmIF;AFjiDI;EEs5CJ;IAUI,uBAAA;EAqIF;AACF;AApIE;EAZF;IAcO,uBAAA;EAsIL;AACF;;AAnIA;EACE,6BAAA;EACA,gBAAA;AAsIF;;AAnIA;EACE,8BAAA;AAsIF;;AAnIA;EACE,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,0CAAA;EACA,4BAAA;EACA,YAAA;AAsIF;AFrkDI;EEi7CJ;IAgBI,QAAA;EAwIF;AACF;;AArIA;EACE,uBAAA;EACA,kBAAA;AAwIF;;AArIA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAwIF;;AApIA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAuIF;;AApIA;EAEE,kBAAA;EACA,mBAAA;AAsIF;;AAnIA;EACE,eAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AAsIF;;AAnIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAsIF;;AAnIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wDAAA;AAsIF;;AAnIA;EACE,0BAAA;EACA,eAAA;AAsIF;;AAnIA;EACE,aAAA;EACA,aAAA;EACA,WAAA;AAsIF;;AAnIA;EACE,0BAAA;EACA,uDAAA;EACA,qBAAA;EACA,mBAAA;AAsIF;AFnpDI;EEygDJ;IAMI,qBAAA;IACA,kBAAA;EAwIF;AACF;;AArIA;EACE,UAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,yCAAA;AAwIF;;AAjIA;EACE,oBAAA;AAoIF;;AAjIA;EACE,+CAAA;EACA,UAAA;EACA,UAAA;AAoIF;;AAjIA;EACE,2BAAA;AAoIF;;AAjIA;EACE,oBAAA;EACA,mBAAA;AAoIF;AAlIE;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAoIN;AF/rDI;EE+jDA;IACE,0BAAA;IACA,qBAAA;EAmIJ;AACF;AAhIE;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AAkIN;AF5sDI;EEqkDF;IAOM,SAAA;IACA,oBAAA;EAoIN;AACF;AAjIE;EACE,UAAA;AAmIJ;;AA/HA;EACE,0BAAA;EACA,uDAAA;EACA,6BAAA;AAkIF;AF3tDI;EEslDJ;IAOI,qBAAA;IACA,kBAAA;EAkIF;AACF;;AFjuDI;EEkmDJ;IAKI,sBAAA;IACA,sBAAA;IACA,YAAA;EA+HF;AACF;;AA3HA;EACE,0BAAA;EACA,uDAAA;EAEA,qBAAA;EACA,mBAAA;AA6HF;AFhvDI;EE8mDJ;IAOI,qBAAA;IACA,mBAAA;EA+HF;AACF;;AA5HA;EACE,sBAAA;EAEA,qBAAA;EACA,YAAA;AA8HF;AF5vDI;EE0nDJ;IAMI,qBAAA;IACA,sBAAA;EAgIF;AACF;;AA3HA;EACE,uBAAA;EACA,kBAAA;AA8HF;AFvwDI;EEuoDJ;IAII,uBAAA;EAgIF;AACF;;AA7HA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0DAAA;EACA,8DAAA;EACA,6BAAA;AAgIF;AFtxDI;EE+oDJ;IASI,uBAAA;EAkIF;AACF;AAjIE;EAXF;IAaO,uBAAA;EAmIL;AACF;;AAhIA;EACE,uBAAA;AAmIF;AFpyDI;EEgqDJ;IAGI,uBAAA;EAqIF;AACF;;AAlIA;EACE,uBAAA;AAqIF;AF7yDI;EEuqDJ;IAGI,uBAAA;EAuIF;AACF;;AApIA;EACE,iBAAA;AAuIF;AFtzDI;EE8qDJ;IAGI,2BAAA;EAyIF;AACF;;AF3zDI;EEqrDJ;IAEI,uBAAA;EAyIF;AACF;;AAtIA;EACE,2BAAA;AAyIF;;AAtIA;EACE,uBAAA;EACA,eAAA;AAyIF;AF10DI;EE+rDJ;IAII,0BAAA;EA2IF;AACF;;AAxIA;EACE,uBAAA;EACA,gBAAA;AA2IF;;AAxIA;EACE,2BAAA;AA2IF;;AAxIA;EACE,iBAAA;AA2IF;;AAxIA;EACE,2BAAA;AA2IF;;AAxIA;EACE,2BAAA;AA2IF;;AAtIA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iDAAA;AAwIF;;AArIA;EACC,oBAAA;AAwID;;AArIA;EACE,mCAAA;EACA,mBAAA;AAwIF;;AArIA;EACE,oCAAA;AAwIF;;AFj4DI;EE4vDJ;IAEI,2BAAA;IACA,8BAAA;EAwIF;AACF;;AFx4DI;EEmwDJ;IAEI,iBAAA;IACA,2BAAA;IACA,8BAAA;EAwIF;AACF;;AArIA;EACE,4BAAA;AAwIF;;AArIA;EACE,iBAAA;AAwIF;;AArIA;EACE,0BAAA;AAwIF;;AAtIA;;;EAGE,2BAAA;EACA,8BAAA;AAyIF;;AAvIA;;;;;EAKE,6BAAA;AA0IF;;AAxIA;;;;;;;EAOE,qBAAA;EACA,6BAAA;AA2IF;;AAzIA;;;EAGE,qBAAA;EACA,6BAAA;AA4IF;;AAzIA;;;EAGE,6BAAA;AA4IF;;AA1IA;EACE,6BAAA;AA6IF;;AA1IA;EACE,wBAAA;AA6IF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\r\n\r\n\r\n.product-selection-page {\r\n  margin-bottom: 60px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  @include respond-to('small'){\r\n    margin-left: -10px;\r\n  }\r\n  .btn-link {\r\n    padding-top: 10px;\r\n    @include respond-to('small'){\r\n      margin-right: 60px;\r\n    }\r\n    @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\r\n      margin-right: 75px;\r\n    }\r\n  }\r\n    // @media only screen and\r\n    // (max-width: 1020px) and (min-width:400px) {\r\n    //   margin-right: 20px ;\r\n    //   }\r\n  \r\n//   @media only screen and (max-width: 1024px) and (min-width:400px){\r\n// .col-sm-12 {\r\n//     width: 65% !important;\r\n// }\r\n//   }\r\n  .pull-right {\r\n    @include respond-to('small'){\r\n    float: right;\r\n    width: 280px ;\r\n    margin-right: -35px ;\r\n    }\r\n    @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\r\n      margin-right: -11px;\r\n    }\r\n  }\r\n  @media (max-width: 600px){\r\n    .alert{margin-left: -44px;\r\n    margin-right: -25px;\r\n    border-radius: 8px;}\r\n    .alert div:first-child {\r\n      border-radius: 8px 0 0 8px;\r\n    }\r\n   .alert .close {\r\n    right: 30px;\r\n    top: -5px;\r\n}}\r\n    // @media only screen and\r\n    // (max-width: 1020px) and (min-width:400px) {\r\n    //   //float: right;\r\n    //   width: 140px !important ;\r\n    //   margin-right: 300px;\r\n    //   }\r\n\r\n  .content-text{\r\n    position: relative;\r\n    height: 139px;\r\n    width: 540px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    @include respond-to('small'){ \r\n      height: 185px;\r\n    width: 325px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    }\r\n  }\r\n  .text-box{\r\n    width:auto;\r\n    display:flex;\r\n    display: -webkit-flex;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    margin-left: -30px;\r\n    margin-top: 10px;\r\n\r\n    @include respond-to('small') {\r\n      width: fit-content;\r\n      flex-direction: column;\r\n      margin: 20px;\r\n      height: 182px;\r\n      margin-top: -3px;\r\n    }\r\n  }\r\n  .text1{\r\n    width:120px;\r\n    height:61px;\r\n    font-size:14px;\r\n    @include respond-to('small') { \r\n      width:100%;//187px;\r\n      height:31px;\r\n      font-size:14px;\r\n      margin-top: 10px;\r\n    }\r\n  }\r\n  .text2{\r\n    width:120px;\r\n    height:61px;\r\n    font-size:14px;\r\n    @include respond-to('small') { \r\n      width:187px;\r\n      height:31px;\r\n      font-size:14px;\r\n      margin-top: 10px;\r\n    }\r\n  }\r\n  .text3{\r\n    width:120px;\r\n    height:61px;\r\n    font-size:14px;\r\n    @include respond-to('small') { \r\n      width:187px;\r\n      height:31px;\r\n      font-size:14px;\r\n      margin-top: -5px;\r\n    }\r\n  }\r\n  .text4{\r\n    width:120px;\r\n    height:61px;\r\n    font-size:14px;\r\n    @include respond-to('small') { \r\n      width:187px;\r\n      height:31px;\r\n      font-size:14px;\r\n      margin-top: 15px;\r\n    }\r\n  }\r\n\r\n  .abmapplyacct:hover {\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  .tooltipActive + .helper-text {\r\n    padding: 10px;\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 280px !important;\r\n    font-size: 11px;\r\n    // left: 480px;\r\n    // top: -95px; \r\n    border-radius: 7px;\r\n    background-color: white;\r\n    border: 1px solid var(--Controls-Border-Floating, #DCDFE3);\r\n    box-shadow: 0px 2px 12px 0px rgba(80, 127, 171, 0.059);\r\n    box-shadow: 0px 2px 4px -1px rgba(37, 48, 58, 0.0588235294);\r\n    box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);\r\n    display: inline-table;\r\n    bottom: 100%;\r\n    // margin-left: -225px;\r\n    margin-bottom: -2px;\r\n    // left: 120px !important;\r\n    // margin-top:32px;\r\n    background-color: white;\r\n    color: black;\r\n    top: 54.5%;\r\n    left: 44%;\r\n    cursor: pointer;\r\n    @include respond-to('small') {\r\n        margin-top:0px;\r\n        margin-bottom: -2px;\r\n        background-color: white;\r\n        top: 33% !important;\r\n        left: 32% !important;\r\n    }\r\n\r\n    @media(max-width: 1024px) {\r\n      z-index: 1;\r\n      // width: 105px;\r\n      margin-top:0px;\r\n      // margin-left: -123px;\r\n  }\r\n}\r\n\r\n\r\n.tooltip-input {\r\n    right: -50px;\r\n    bottom: 8px;\r\n    width: 30px;\r\n\r\n    @include respond-to('small') {\r\n        right: -200px;\r\n        bottom: 50px;\r\n        width: 35px;\r\n    }\r\n}\r\n\r\n  .content-wrapper {\r\n    position: relative;\r\n    height: 200px;\r\n    width: 540px;\r\n    padding: 15px;\r\n    margin-left: 10px;\r\n\r\n    @include respond-to('small') {\r\n      display:flex;\r\n      flex-direction: row;\r\n      padding: 0px !important;\r\n      width: 300px;\r\n    }\r\n  }\r\n  \r\n  .ng-modal-number-container {\r\n    margin-top: 25px;\r\n    background-color:#f1f2f3;\r\n    border-top: 5px solid #1483d9;\r\n    width:auto;\r\n    display:flex;\r\n    display: -webkit-flex;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    @include respond-to('small') {\r\n      flex-direction: column;\r\n      border-top: px solid #1483d9;\r\n      height: 155px;\r\n    }\r\n  }\r\n  \r\n  .numberContainer {\r\n    margin-top: -23px;\r\n  }\r\n  \r\n  .numberIcon {\r\n    width:45px;\r\n    height:45px;\r\n    border-radius:50%;\r\n    font-size:18px;\r\n    color:#f1f2f3;\r\n    line-height:42px;\r\n    text-align:center;\r\n    background:#1483d9;\r\n    border:2px solid #1483d9;\r\n    @include respond-to('small') {\r\n      width:32px;\r\n      height:32px;\r\n      font-size:16px;\r\n      text-align:center;\r\n      line-height:32px;\r\n    }\r\n  }\r\n  .supportArticle{\r\n    h3 {\r\n      font: 24px;\r\n      margin-top: 20px;\r\n      font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    }\r\n    ul{\r\n      list-style-type: disc;\r\n    }\r\n    li{\r\n      list-style-type: disc;\r\n    }\r\n    .padding{\r\n      padding-left:38px;\r\n    }\r\n  }\r\n  \r\n    @include respond-to (small) {\r\n    margin-bottom: 30px;\r\n    padding-top: 50px\r\n  }\r\n}\r\n\r\n.btn-abm {\r\n  border: 1px solid var(--unnamed-color-1483d9);\r\n  background: #1483D9 0% 0% no-repeat padding-box;\r\n  border: 1px solid #1483D9;\r\n  border-radius: 6px;\r\n  opacity: 1;\r\n  font-size: 17px;\r\n}\r\n\r\n#ztpradio{\r\n  margin-top: -95px;\r\n  margin-left: -5px;\r\n\r\n  @include respond-to (small) {\r\n    margin-top: -100px;\r\n    margin-left: 70px;\r\n  }\r\n}\r\n\r\n.container-flex {\r\n  display: inline-flex !important;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  justify-content: space-around;\r\n  align-content: center;\r\n  align-items: flex-start;\r\n  margin-left: -20px;\r\n  width: 100%;\r\n  padding-top: 15px;\r\n  \r\n  @include respond-to (small) {\r\n    width: 100%;\r\n    //flex-wrap: wrap;\r\n    margin-left: -60px;//-70px;\r\n    flex-direction: column;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1020px) and (min-width:400px) {\r\n    margin-left: -50px;\r\n     }\r\n}\r\n\r\n.container-flex > div {\r\n  margin: 10px;\r\n}\r\n\r\n.flex-box {\r\n  //max-width: 400px;\r\n  @include respond-to (small) {\r\n    //max-width: 100px;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1020px) and (min-width:400px) {\r\n    margin-left: 0px;\r\n     }\r\n}\r\n\r\n.container1 {\r\n  top: 356px;\r\n  left: 421px;\r\n  width: 186px;\r\n  height: 200px;\r\n  padding: 20px;\r\n  //margin-left: -28px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box;\r\n  border: 2px solid color(default, dark);\r\n  //border: 1px solid #707070;\r\n  opacity: 1;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  @include respond-to (small) {\r\n    // font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    // margin-left: 50px;\r\n    width: 325px;\r\n    height: 170px;\r\n  }\r\n\r\n \r\n}\r\n\r\n@include respond-to (small) {\r\n  .conditional-display {\r\n    // height: 70px !important;\r\n    visibility: hidden;\r\n  }\r\n}\r\n//   .mobile-blueLine {\r\n//     top: -28px;\r\n//   } \r\n\r\n\r\n.container1.selected-border {\r\n  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);\r\n  border-bottom: none;\r\n}\r\n\r\n.container2 {\r\n  top: 356px;\r\n  left: 626px;\r\n  width: 186px;\r\n  height: 200px;\r\n  padding: 20px;\r\n  padding-left: 13px;\r\n  //margin-left: -12px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box;\r\n  border: 2px solid color(default, dark);\r\n  //border: 1px solid #707070;\r\n  opacity: 1;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  @include respond-to (small) {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-left: 50px;\r\n    width: 325px;\r\n    height: 160px;\r\n  }\r\n}\r\n\r\n.container2.selected-border {\r\n  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);\r\n  border-bottom: none;\r\n}\r\n\r\n.container3 {\r\n  top: 356px;\r\n  left: 835px;\r\n  width: 186px;\r\n  height: 200px;\r\n  padding: 20px;\r\n  padding-left: 13px;\r\n  //margin-left: 4px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box;\r\n  border: 2px solid color(default, dark);\r\n  //border: 1px solid #707070;\r\n  opacity: 1;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  @include respond-to (small) {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-left: 50px;\r\n    width: 325px;\r\n    height: 160px;\r\n  }\r\n}\r\n\r\n.container3.selected-border {\r\n  border: 2px solid var(--Card-Selectable-Selected-border, #009FDB);\r\n  border-bottom: none;\r\n}\r\n\r\n.row {\r\n  margin-left: 0px;\r\n  margin-right: 0px !important;\r\n  @include respond-to (small){\r\n    //margin-top: -15px;\r\n  }\r\n}\r\n\r\n.enroll {\r\n  top: 381px;\r\n  left: 491px;\r\n  padding-left: 45px;\r\n  width: 46px;\r\n  height: 15px;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  letter-spacing: 0.4px;\r\n  color: #000000;\r\n  opacity: 1;\r\n  @include respond-to(small){\r\n  padding-left: 65px;\r\n  }\r\n}\r\n\r\n.service {\r\n  top: 424px;\r\n  left: 442px;\r\n  width: 144px;\r\n  height: 45px;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  letter-spacing: 0.6px;\r\n  color: #000000;\r\n  opacity: 1;\r\n  //padding: 0px 9px 0px 9px;\r\n  p {\r\n    margin-bottom: 0px !important;\r\n  }\r\n  @include respond-to (small){\r\n    width: 192px;\r\n    margin-left: 40px;\r\n  }\r\n}\r\n\r\n.radio-button {\r\n  top: 495px;\r\n  left: 501px;\r\n  width: 25px;\r\n  height: 25px;\r\n  padding: 20px 0 0 60px;\r\n  // margin-top: 20px;\r\n  @include respond-to(small){\r\n    margin-top: -1px;\r\n    margin-left: 60px;\r\n  }\r\n\r\n}\r\n\r\n.msg-box {\r\n  top: 577px;\r\n  left: 421px;\r\n  width: 602px;\r\n  // height: 205px;\r\n  background: #F1F2F3 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  padding: 30px;\r\n  margin-top: 20px;\r\n  margin-bottom: 7px;\r\n  padding-top: 30px;\r\n  padding-bottom: 30px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  p{\r\n    margin-bottom: 10px !important;\r\n    margin-top: 5px;\r\n  }\r\n  @include respond-to (small) {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-top: -25px;\r\n    margin-left: 5px;\r\n    width: 325px;\r\n    // height: 335px;\r\n    font-size: 16px;\r\n    p{\r\n      margin-bottom: 10px;\r\n      margin-top: 10px;\r\n    }\r\n    @media only screen and\r\n   (max-width: 1220px) and (min-width:920px) {\r\n    width: 325px;\r\n     }\r\n  }\r\n}\r\n\r\n.msg-box1 {\r\n  top: 577px;\r\n  left: 421px;\r\n  width: 602px;\r\n  // height: 190px;\r\n  background: #F1F2F3 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  padding: 20px 20px 30px 20;\r\n  margin-top: 20px;\r\n  margin-bottom: 30px;\r\n  // padding-bottom: 30px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  p{\r\n    margin-bottom: 5px;\r\n  }\r\n  @include respond-to (small) {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-top: 10px;\r\n    width: 325px;\r\n    // height: 200px;\r\n    //margin-left: -35px;\r\n    p{\r\n      margin-bottom: 5px;\r\n    }\r\n  }\r\n  @media only screen and\r\n   (max-width: 700px) and (min-width:920px) {\r\n    width: 325px !important;\r\n     }\r\n  @media only screen and\r\n   (max-width: 1220px) and (min-width:1020px) {\r\n    width: 445px;\r\n     }\r\n}\r\n\r\n.msg-box1-zte {\r\n  top: 577px;\r\n  left: 421px;\r\n  width: 598px;\r\n  background: #F1F2F3 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  padding: 30px;\r\n  margin-top: 20px;\r\n  margin-bottom: 7px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n\r\n  p{\r\n    margin-bottom: 10px;\r\n    margin-top: 5px;\r\n  }\r\n  @include respond-to (small) {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-top: 10px;\r\n    width: 325px;\r\n    // height: 444px;\r\n    //margin-left: -35px;\r\n    p{\r\n      margin-bottom: 5px;\r\n    }\r\n  }\r\n  @media only screen and\r\n   (max-width: 700px) and (min-width:920px) {\r\n    width: 325px !important;\r\n     }\r\n  @media only screen and\r\n   (max-width: 1220px) and (min-width:1020px) {\r\n    width: 445px;\r\n     }\r\n}\r\n\r\n.field {\r\n  top: 693px;\r\n  left: 437px;\r\n  width: 560px !important;\r\n  height: 36px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  //border: 1px solid #D1D2D3 !important;\r\n  border-radius: 5px !important;\r\n  //opacity: 1;\r\n  //padding-top: 1px;\r\n  @include respond-to (small) {\r\n    width: 280px !important;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1220px) and (min-width:920px) {\r\n       width: 280px !important;\r\n     }\r\n}\r\n\r\n.disableLabel{\r\n  cursor: auto;\r\n}\r\n\r\nh1 {\r\n  margin-top: 30px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n}\r\nhr{\r\n  margin-top: 30px;\r\n  margin-bottom: 30px;\r\n  @include respond-to (small){\r\n    width: 325px;\r\n    margin-left: -46px !important;\r\n  } @media only screen and\r\n  (max-width: 1020px) and (min-width:400px) {\r\n    width: 325px;\r\n    margin-left: -46px !important;\r\n    }\r\n}\r\nh3 {\r\n  font: 24px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  margin-top: 30px;\r\n  margin-bottom: 20px;\r\n  @include respond-to (small){\r\n    font: 16px;\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  }\r\n}\r\n.heading-small-content-ibm {\r\n  font: 18px !important;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  margin-bottom: 10px;\r\n  @include respond-to (small){\r\n    font-size: 14px !important;\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  }\r\n}\r\n.productselection-description1 {\r\n  margin-bottom: 30px;\r\n  letter-spacing: var(--unnamed-character-spacing-0-53);\r\n  font-size: 16px !important;\r\n  @include respond-to (small){\r\n    width: 325px;\r\n    margin-left: -30px;\r\n  }\r\n  @media only screen and\r\n  (max-width: 1020px) and (min-width:400px) {\r\n   //margin-left: 100px;\r\n    }\r\n}\r\n.productselection-header2 {\r\n  margin-bottom: 30px;\r\n}\r\nh4 {\r\n  font: 18px;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  margin-bottom: 10px;\r\n  @include respond-to (small){\r\n    font: 16px;\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    margin-top: -15px !important;\r\n    margin-left: 46px !important;\r\n    margin-bottom: 6px !important;\r\n  }\r\n}\r\n\r\n#abmHeading {\r\n  top: 701px;\r\n  left: 274px;\r\n  width: 290px;\r\n  height: 29px;\r\n  margin-left: 130px;\r\n  text-align: center;\r\n  font-family: normal normal medium 22px/21px ATT Aleck Sans !important;\r\n  font-size: 22px;\r\n  letter-spacing: 0.18px;\r\n  color: #000000;\r\n  opacity: 1;\r\n  @include respond-to('small'){\r\n    width: 242px;\r\n    height: 32px;\r\n    margin-left: 20px;\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n.innerCont {\r\n  padding: 0px 50px 0px 0px;\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  @include respond-to('small'){ \r\n    padding: 0px 20px 0px 20px;\r\n  }\r\n}\r\n\r\n.innerCont-qsn {\r\n  padding: 5px 50px 0px 0px;\r\n  font-size: 16px;\r\n  @include respond-to('small'){ \r\n    padding: 0px 20px 0px 20px;\r\n  }\r\n}\r\n\r\n.addSpace1 {\r\n  padding-top: 5px;\r\n  @include respond-to (small){\r\n    margin: 10px 0px;\r\n    word-wrap: break-word;\r\n    max-width: 395px;\r\n    margin-left: -27px;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1020px) and (min-width:400px){\r\n    max-width: 325px;\r\n    margin-left: -30px;\r\n  }\r\n}\r\n\r\n.addSpace {\r\n  margin: 0px 0px 0px 0px;\r\n  @include respond-to (small){\r\n    margin: 0px 0px 0px 0px;\r\n  }\r\n}\r\n\r\n.blueLine{\r\n  padding-top: 20px;\r\n}\r\n@media only screen and (max-width: 1020px){\r\n  .blueLine{\r\n  padding-top: 0px}\r\n }\r\n\r\n\r\n.product-selection-container {\r\n\r\n  h1 {\r\n    padding-left: 5px;\r\n    @include respond-to (small){\r\n      margin-left: -35px;\r\n      font-size: 28px;\r\n      margin-top: 35px;\r\n    }\r\n    @media only screen and\r\n   (max-width: 1020px) and (min-width:400px) {\r\n    //margin-left: 95px;\r\n     }\r\n  }\r\n  margin: 0 16.66%;\r\n\r\n  // .gId, .kmeId {\r\n  //   display: none;\r\n  //   padding: 10px 0px 10px 0px;\r\n  //   width:40% !important;\r\n  // }\r\n\r\n  .live{\r\n    padding: 10px 0px 0px 0px;\r\n  }\r\n\r\n  .subLabel,\r\n  input[type=text] {\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    color: #191919;\r\n    font-size: 16px;\r\n    //border: none;\r\n    width: 560px ;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box !important;\r\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n    border: 1px solid #D1D2D3 !important;\r\n    border-radius: 5px !important;\r\n\r\n    @include respond-to (small){\r\n      width: 280px ;\r\n    }\r\n    @media only screen and\r\n   (max-width: 1220px) and (min-width:920px) {\r\n       width: 370px;\r\n     }\r\n     @media only screen and\r\n   (max-width: 1050px) and (min-width:750px) {\r\n       width: 285px ;\r\n     }\r\n  }\r\n\r\n  .article{\r\n    padding: 3px;\r\n    margin-left: 15px;\r\n  }\r\n\r\n  .subHeader{\r\n    font-size:22px;\r\n  }\r\n  .error-container {\r\n    .message {\r\n      font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n      font-size: 14px;\r\n      padding: 3px 0;\r\n    }\r\n  }\r\n  .googleId, .samsungId, .appleId {\r\n    padding: 20px 0px 0px 0px;\r\n    display: none;\r\n  }\r\n\r\n  .tooltip-container i.tooltip-icon {\r\n    display: none;\r\n  }\r\n\r\n  .form-control{\r\n    width:552px;\r\n    @include respond-to (small){\r\n      width:235px;\r\n    }\r\n  }\r\n\r\n  .gtooltip, .stooltip{\r\n    bottom: 29px;\r\n    left:350px !important;\r\n    @include respond-to (small){\r\n      bottom: 30px;\r\n      left:260px !important;\r\n    }\r\n    @media only screen and (max-width: 1025px) and (min-width: 508px){\r\n      bottom: 0px;\r\n      left: -30px !important;\r\n    }\r\n  }\r\n\r\n  i.tooltip-icon::after { \r\n    @media only screen and (max-width: 1025px) and (min-width: 508px){\r\n      margin-top: -10px;\r\n    }\r\n  }\r\n  .helper-text{\r\n    // left: 340px;\r\n    top: 0px;\r\n    @include respond-to (small){\r\n      left: 0px;\r\n      top: 33px;  \r\n    }\r\n   @media only screen and (max-width: 1025px) and (min-width: 508px){\r\n      // left: -290px;\r\n      top: 37px;\r\n   }\r\n  }\r\n\r\n  #samsung-name-error, #google-name-error, #google-name-error1, #google-name-error2, #google-name-error3, #google-name-error4{\r\n    margin-top: -10px;\r\n    @media only screen and (max-width: 1025px) and (min-width: 508px){\r\n      margin-top: 5px;\r\n    }\r\n  }\r\n\r\n  .changeNonIBM , .changeIBM{\r\n    border: 1px solid grey;\r\n    border-radius: 15px;\r\n    padding:15px 15px 5px 15px;\r\n    margin: 20px 0px 20px 0px;\r\n    display: none;\r\n  }\r\n  .selectedDetails, .selectedDetailsKme{\r\n    padding:20px 0px 20px 35px;\r\n    //line-height: 45px;\r\n    display:none;\r\n  }\r\n  .product-brief-link-kme, .product-brief-link-ztp {\r\n    margin-left: 5px;\r\n  }\r\n  \r\n}\r\n\r\n.radio input + .skin {\r\n  border-radius: 100%;\r\n}\r\n\r\n.box1 {\r\n  top: 549px;\r\n  left: 421px;\r\n  width: 38px;\r\n  height: 7px;\r\n  background: #61CFFB 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: -22px;\r\n  margin-top: 46px;\r\n  @include respond-to(small){\r\n    width: 90px;\r\n    margin-left: -23px;\r\n    margin-top: 30px;\r\n\r\n  }\r\n}\r\n\r\n.box2 {\r\n  top: 549px;\r\n  left: 450px;\r\n  width: 39px;\r\n  height: 7px;\r\n  background: #52B6EB 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: 5px;\r\n  margin-top: -7px;\r\n  @include respond-to(small){\r\n    width: 90px; \r\n    margin-left: 18px;\r\n  }\r\n}\r\n\r\n.box3 {\r\n  top: 549px;\r\n  left: 480px;\r\n  width: 39px;\r\n  height: 7px;\r\n  background: #3E9DD6 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: 35px;\r\n  margin-top: -7px;\r\n  @include respond-to(small){\r\n    width: 90px; \r\n    margin-left: 68px;\r\n  }\r\n}\r\n\r\n.box4 {\r\n  top: 549px;\r\n  left: 509px;\r\n  width: 39px;\r\n  height: 7px;\r\n  background: #3386C5 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: 65px;\r\n  margin-top: -7px;\r\n  @include respond-to(small){\r\n    width: 90px; \r\n    margin-left: 116px;\r\n  }\r\n}\r\n\r\n.box5 {\r\n  top: 549px;\r\n  left: 539px;\r\n  width: 39px;\r\n  height: 7px;\r\n  background: #286EB8 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: 95px;\r\n  margin-top: -7px;\r\n  @include respond-to(small){\r\n    width: 90px; \r\n    margin-left: 165px;\r\n  }\r\n}\r\n\r\n.box6 {\r\n  top: 549px;\r\n  left: 569px;\r\n  width: 37px;\r\n  height: 7px;\r\n  background: #1F56A9 0% 0% no-repeat padding-box;\r\n  opacity: 1;\r\n  margin-left: 127px;\r\n  margin-top: -7px;\r\n  @include respond-to(small){\r\n    width: 90px; \r\n    margin-left: 213px;\r\n  }\r\n}\r\n\r\n.efota-section {\r\n  .efota-paragraph {\r\n    margin-bottom: 0px;\r\n  }\r\n  .efota-link {\r\n    cursor: pointer;\r\n  }\r\n  .efota-link:hover {\r\n    text-decoration: underline;\r\n  }\r\n  @include respond-to (small){\r\n    width: 325px;\r\n    margin-left: -45px;\r\n  }\r\n}\r\n\r\n//loading modal style\r\n\r\n.loginModal{\r\n    padding-left: 3px;\r\n  .btn-secondary{\r\n    width: 324px;\r\n  }\r\n}\r\n\r\n.model-box-loginModal{\r\n    border-radius: 8px;\r\n    animation: animatetop 0.4s;\r\n    background: white;\r\n    margin: 0 auto;\r\n    max-height: 80%;\r\n    max-width: 620px;\r\n    overflow: auto;\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n    position: relative;\r\n    top: 35%;\r\n    // box-shadow: 0 3px 8px 3px rgba(255, 255, 255, 0);\r\n    // padding: 20px 0 0px 9px;\r\n    padding:15px;\r\n    width: 348px;\r\n    // height: 182px;\r\n    text-align: center;\r\n    font-weight: 700;\r\n}\r\n\r\n.model-cover .model-box-loginModal{\r\n  background: 0 3px 8px 3px rgba(255, 255, 255, 0) !important;\r\n}\r\n\r\n.model-cover{\r\n  background: 0 3px 8px 3px rgba(255, 255, 255, 0) !important;\r\n}\r\n\r\n.model-box{\r\n  box-shadow: none !important;\r\n}\r\n\r\n.spinner{\r\n  width: 100%;\r\n  margin-bottom: 5px;\r\n}\r\n.spinner img{\r\n  align-items: center;\r\n  width: 35px;\r\n}\r\n\r\n.loading-text{\r\n  display: inline-grid;\r\n}\r\n\r\n.content-text i.tooltip-icon.tooltipActive:after{\r\n  margin-top: 32px;\r\n}\r\n\r\n.valign-children-middle p{\r\n  padding:10px;\r\n}\r\n\r\n.mr-5{\r\n  margin-top:5px !important;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.mr-10{\r\n  margin-top:10px;\r\n}\r\n\r\n.mr-17{\r\n  margin-top:17px;\r\n}\r\n\r\n.mr-25{\r\n  margin-top:25px;\r\n}\r\n\r\n.mr-30{\r\n  margin-top:30px;\r\n}\r\n\r\n.mr-40{\r\n  margin-top:40px;\r\n}\r\n\r\n.mb-10{\r\n  margin-bottom:10px;\r\n}\r\n\r\n.pointer-sym{\r\n  cursor: pointer;\r\n}\r\n\r\n.disabledDiv{\r\n  // pointer-events: none;\r\n  opacity: 0.3;\r\n}\r\n\r\n.google-ztp-icon, .apple-abm-icon{\r\n  width: 100px;\r\n  // height: 19px;\r\n}\r\n\r\n.sub-content{\r\n  font-size: 14px;\r\n  font-weight: 400 !important;\r\n  text-align: center;\r\n  min-height: 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n\r\n.tile-heading { \r\n  width: 160px;\r\n}\r\n\r\n.progress-bar {\r\n  // display: flex;\r\n  // justify-content: center;\r\n  // margin: 20px 0;\r\n  width: 598px;\r\n  margin-left: 3px;\r\n  @include respond-to ('small') {\r\n    width: 323px;\r\n    margin-left: -22px;\r\n  }\r\n}\r\n\r\n.progress-steps {\r\n  list-style: none;\r\n  display: flex;\r\n  padding: 0;\r\n  margin: 0;\r\n\r\n  // @media screen and (max-width: 1024px) {\r\n  //   visibility: hidden;  \r\n  // }\r\n}\r\n\r\n\r\n\r\n.progress-steps .step1 {\r\n  padding: 10px 20px;\r\n  border-bottom: 3px solid #D2D2D2;\r\n  // color: #666;\r\n  font-size: 14px;\r\n  // text-align: center;\r\n  flex: 1;\r\n  width: 186px;\r\n  padding-left: 0px;\r\n  @include respond-to ('small') {\r\n    width: 107px;\r\n  }\r\n}\r\n\r\n.progressBar-highlight {\r\n  border-bottom: 3px solid var(--ATT-Blue, #009FDB) !important;\r\n}\r\n.stepper-text {\r\n  color: var(--ATT-Blue, #009FDB);\r\n}\r\n\r\n.progress-steps .step2 {\r\n  padding: 10px 20px;\r\n  border-bottom: 3px solid #D2D2D2;\r\n  margin-left: 5px;\r\n  font-size: 14px;\r\n  // text-align: center;\r\n  flex: 1;\r\n  width: 186px;\r\n  padding-left: 0px;\r\n  @include respond-to ('small') {\r\n    width: 107px;\r\n  }\r\n}\r\n\r\n@include respond-to ('small') {\r\n.step2 span {\r\n  white-space: nowrap;\r\n  overflow: hidden;    \r\n  text-overflow: ellipsis; \r\n}\r\n}\r\n\r\n.progress-steps .step3 {\r\n  padding: 10px 20px;\r\n  border-bottom: 3px solid #D2D2D2;\r\n  margin-left: 5px;\r\n  font-size: 14px;\r\n  flex: 1;\r\n  width: 186px;\r\n  padding-left: 0px;\r\n  @include respond-to ('small') {\r\n    width: 107px;\r\n  }\r\n}\r\n\r\n.radio-group {\r\n  display: flex;\r\n  gap: 40px;\r\n  align-items: center;\r\n  padding-left: 45px;\r\n  margin-top: -6px;\r\n  @include respond-to('small'){ \r\n    flex-direction: column; \r\n    gap: 15px; \r\n    padding-left: 20px;\r\n    align-items: flex-start !important;\r\n  }\r\n}\r\n\r\n.option-label {\r\n  margin-left: 28px;\r\n  font-family: ATT Aleck Sans;\r\n  font-size: 14px;\r\n}\r\n\r\n.continue-btn {\r\n  border-radius: 42px;\r\n  height: 32px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: var(--Controls-Button-Primary-Fill, #00388F);\r\n  font-size: 15px;\r\n  @include respond-to('small') {\r\n    width: 100px !important;\r\n    margin-right: 10px !important;\r\n  }\r\n}\r\n\r\n.align-button {\r\n  padding-top: 12px;\r\n  padding-right: 0px;\r\n  @include respond-to('small') {\r\n    // margin-left: 55px;\r\n  }\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 35px;\r\n  @include respond-to('small') {\r\n    gap: 25px;\r\n    margin-top: 25px;\r\n  }\r\n}\r\n\r\n.home-btn{\r\n  min-width: 100px;\r\n  height: 32px;\r\n  opacity: 1;\r\n  gap: 10px;\r\n  font-size: 15px;\r\n  border-radius: 48px;\r\n  border-width: 2px;\r\n  padding-top: 8px;\r\n  padding-right: 24px;\r\n  padding-bottom: 8px;\r\n  padding-left: 24px;\r\n  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);\r\n  background: var(--Controls-Button-Primary-Fill, #00388F);\r\n  color: var(--Controls-Button-Secondary-Text-icon, #e8ebf0);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  @include respond-to('small'){\r\n    font-size: 15px;\r\n    width:133px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n}\r\n\r\n\r\n.back-btn {\r\n  min-width: 100px;\r\n  height: 32px;\r\n  opacity: 1;\r\n  gap: 10px;\r\n  border-radius: 48px;\r\n  border-width: 2px;\r\n  padding-top: 8px;\r\n  padding-right: 24px;\r\n  padding-bottom: 8px;\r\n  padding-left: 24px;\r\n  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);\r\n  background: #F1F2F3 0% 0% no-repeat padding-box !important;\r\n  color: var(--Controls-Button-Secondary-Text-icon, #00388F);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 15px;\r\n}\r\n\r\n// .align-tooltip {\r\n//   display: flex;\r\n//   justify-content: space-between;\r\n//   align-items: center;\r\n// }\r\n\r\n.tooltip-div {\r\n  right: 452px !important;\r\n}\r\n\r\n.tooltip-text {\r\n  padding: 10px;\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 279px;\r\n    font-size: 11px;\r\n    // left: 480px;\r\n    // top: -95px; \r\n    border-radius: 7px;\r\n    background-color: white;\r\n    border: 1px solid var(--Controls-Border-Floating, #DCDFE3);\r\n    box-shadow: 0px 2px 12px 0px rgba(80, 127, 171, 0.059);\r\n    box-shadow: 0px 2px 4px -1px rgba(37, 48, 58, 0.0588235294);\r\n    box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);\r\n    @include respond-to (small){\r\n      top: -151px !important;\r\n      left: 125px;\r\n    }\r\n}\r\n\r\n.copy-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n  padding-left: 20px;\r\n  cursor: pointer;\r\n  width: 42px;\r\n  @include respond-to (small){\r\n      margin-left: 21%;\r\n  }\r\n}\r\n\r\n.reseller-id {\r\n  margin-top: 6px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.copied-message {\r\n  color: var(--Controls-Button-Secondary-Text-icon, #00388F);\r\n  font-size: 1rem;\r\n  margin-left: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n// .orgId-msgbox {\r\n//   height: 345px !important;\r\n\r\n//   @include respond-to('small') {\r\n//     height: 470px !important;\r\n//   }\r\n// }\r\n\r\n.orgId-field {\r\n  margin-left: 35px;\r\n  @include respond-to('small') {\r\n    margin-left: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n.input-field {\r\n  width: 470px !important;\r\n}\r\n\r\nh6 {\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n// .progress-steps .step.active {\r\n//   border-bottom: 2px solid #007bff;\r\n//   color: #007bff;\r\n//   font-weight: bold;\r\n// }\r\n\r\n.account-info{\r\n  width: 100%;\r\n  max-width: 400px;\r\n  margin-left: 30px;\r\n  table-layout: fixed;\r\n}\r\n\r\n.account-info td {\r\n  padding: 0px;\r\n  border-color: transparent;\r\n}\r\n\r\n.mob-email {\r\n  max-width: 0;\r\n  overflow-wrap: anywhere;\r\n  word-break: break-word;\r\n}\r\n\r\n.tableData {\r\n  padding-right: 50px !important;\r\n}\r\n\r\n.abmAcc-info {\r\n  @include respond-to('small'){\r\n    margin-left: 0px;\r\n  }\r\n}\r\n\r\n.abmAcc-info td {\r\n  @include respond-to('small'){\r\n  width: 76px;\r\n  }\r\n}\r\n\r\n.heading-1 {\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n  margin-left: 30px;\r\n  margin-bottom: 13px !important;\r\n}\r\n\r\n.ABMheading {\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n  margin-left: 30px;\r\n  margin-bottom: 13px !important;\r\n  @include respond-to('small') {\r\n    margin-left: 0px;\r\n  }\r\n}\r\n\r\n.step{\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.fan-selection-page{\r\n  margin-top:0px !important;\r\n  margin-left: 15px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  router-outlet[name=\"mobile-view\"] {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Hide desktop outlet on mobile */\r\n@media screen and (max-width: 767px) {\r\n  router-outlet[name=\"desktop-desktop\"] {\r\n    display: none;\r\n  }\r\n}\r\n.content-spacing {\r\n  margin-top: 20px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.orgId-input {\r\n  top: 693px;\r\n  left: 437px;\r\n  width: 470px !important;\r\n  height: 36px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  border-radius: 7px !important;\r\n  margin-bottom: 20px !important;\r\n  @include respond-to (small) {\r\n    width: 280px !important;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1220px) and (min-width:920px) {\r\n       width: 280px !important;\r\n     }\r\n}\r\n\r\n.paragraph-spacing {\r\n  margin-bottom: 5px !important;\r\n  margin-top: 20px;\r\n}\r\n\r\n.model-cover {\r\n  background: rgba(0, 0, 0, 0.7);;\r\n}\r\n\r\n.model-box-loginModal{\r\n  border-radius: 8px;\r\n  animation: animatetop 0.4s;\r\n  background: white;\r\n  margin: 0 auto;\r\n  max-height: 92%;\r\n  max-width: 620px;\r\n  overflow: auto;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  position: relative;\r\n  top: 2%;\r\n  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);\r\n  padding: 20px 32px 32px 32px;\r\n  width: 360px;\r\n  @include respond-to('small'){\r\n    top: 10%;\r\n    }\r\n}\r\n\r\n.modal-header-loginModal{\r\n  padding: 0px !important;\r\n  position: relative;\r\n}\r\n\r\n.modalHeading {\r\n  color: #3A6EB2;\r\n  text-align: center;\r\n  margin-bottom: 13px;\r\n  font-family: ATT Aleck Sans;\r\n  font-weight: 700;\r\n  font-style: Bold;\r\n  font-size: 36px;\r\n  leading-trim: NONE;\r\n  line-height: 100%;\r\n  letter-spacing: 0.75px;\r\n\r\n}\r\n\r\n.confirm-msg {\r\n  font-size: 14px; \r\n  margin-bottom: 10px; \r\n  font-weight: 100; \r\n  text-align: left;\r\n}\r\n\r\n.confirmation-span {\r\n  // font-size: 15px;\r\n  text-align: center;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.understand-btn {\r\n  font-size: 15px;\r\n  height: 35px;\r\n  display: inline-block;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.continue-div {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.center-button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  border-radius: 42px;\r\n  background: var(--Controls-Button-Primary-Fill, #00388F);\r\n}\r\n\r\n.cancel-link {\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.new-tooltip-input {\r\n  right: -500px;\r\n  bottom: -10px;\r\n  width: 32px;\r\n}\r\n\r\n.tooltip-new {\r\n  font-size: 17px !important;\r\n  color: var(--Controls-Tooltip-icon, #454B52) !important;\r\n  top: 438px !important;\r\n  margin-right: 310px;\r\n  @include respond-to (small){\r\n    top: 352px !important;\r\n    margin-right: 82px;\r\n  }\r\n}\r\n\r\n.tooltip-content {\r\n  width: 300;\r\n  height: 67.00012969970703;\r\n  angle: 0 deg;\r\n  opacity: 1;\r\n  border-width: 1px;\r\n  border-radius: 4px;\r\n  color: black;\r\n  top: 425px !important;\r\n  background-color: white;\r\n  background: var(--Controls-Fill, #FFFFFF);\r\n  // height: 66px;\r\n  // box-shadow: 0px 2px 12px 0px #25303A0F;\r\n  // box-shadow: 0px 2px 4px -1px #25303A0F;\r\n  // box-shadow: 0px 2px 8px 0px #25303A1F;\r\n}\r\n\r\n.appleValue-error {\r\n  padding-bottom: 10px;\r\n}\r\n\r\ni.tooltip-icon.tooltipActive:after {\r\n  background-color:  var(--Controls-Fill, #FFFFFF);\r\n  top: -17px;\r\n  right: 0px;\r\n}\r\n\r\n.radio-btn {\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.align-tooltip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n\r\n  p {\r\n      margin: 0;\r\n      padding: 0;\r\n      display: inline;\r\n      line-height: 1.5; \r\n  }\r\n\r\n  @include respond-to (small){\r\n    .tooltip-abm {\r\n      margin-top: 10% !important;\r\n      left: -22% !important;\r\n    }\r\n  }\r\n\r\n  .tooltip-icon {\r\n      margin: 0; \r\n      padding: 0; \r\n      vertical-align: middle;\r\n      right: 40%; \r\n      top: 9px !important;\r\n      @include respond-to (small){\r\n        right: 3%;\r\n        top: 19px !important;\r\n      }\r\n  }\r\n\r\n  .tooltip-icon-kme {\r\n    right: 80%;\r\n  }\r\n}\r\n\r\n.tooltip-new-zte {\r\n  font-size: 17px !important;\r\n  color: var(--Controls-Tooltip-icon, #454B52) !important;\r\n  position: relative !important;\r\n  // top: 348px !important;\r\n  // margin-right: 330px;\r\n  @include respond-to (small){ \r\n    top: 176px !important;\r\n    margin-right: 45px;\r\n  }\r\n}\r\n\r\n.tooltip-text-zte {\r\n  // left: 466px !important;\r\n  // top: 237px !important;\r\n  // color: black;\r\n  @include respond-to (small) {\r\n    left: 147px !important;\r\n    top: -325px !important;\r\n    color: black;\r\n  }\r\n}\r\n\r\n\r\n.tooltip-new-kme {\r\n  font-size: 17px !important;\r\n  color: var(--Controls-Tooltip-icon, #454B52) !important;\r\n  // top: 348px !important;\r\n  top: 439px !important;\r\n  margin-right: 550px;\r\n  @include respond-to (small){ \r\n    top: 198px !important;\r\n    margin-right: 130px;\r\n  }\r\n}\r\n\r\n.tooltip-text-kme {\r\n  left: 250px !important;\r\n  // top: 238px !important;\r\n  top: 328px !important;\r\n  color: black;\r\n  @include respond-to (small) {\r\n    left: 72px !important;\r\n    top: -306px !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n.form-input {\r\n  width: 470px !important;\r\n  padding-left: 10px;\r\n  @include respond-to (small) {\r\n    width: 240px !important;\r\n  }\r\n}\r\n\r\n.orgId-input-zte {\r\n  top: 693px;\r\n  left: 437px;\r\n  width: 470px !important;\r\n  height: 36px;\r\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\r\n  font-family: Regular 12px/21px ATTAleckSans-Regular !important;\r\n  border-radius: 7px !important;\r\n  @include respond-to (small) {\r\n    width: 240px !important;\r\n  }\r\n  @media only screen and\r\n   (max-width: 1220px) and (min-width:920px) {\r\n       width: 240px !important;\r\n   }\r\n}\r\n\r\n.google-input{\r\n  width: 455px !important;\r\n  @include respond-to (small) {\r\n    width: 240px !important;\r\n  }\r\n}\r\n\r\n.google-field{\r\n  width:455px !important;\r\n  @include respond-to (small) {\r\n    width: 240px !important;\r\n  }\r\n}\r\n\r\n.field-section{\r\n  margin-left:35px;\r\n  @include respond-to (small){\r\n    margin-left:0px !important;\r\n  }\r\n}\r\n\r\n.acc-info{\r\n   @include respond-to (small){\r\n    width: 255px !important;\r\n  }\r\n}\r\n\r\n.p-spacing{\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.content-info{\r\n  padding: 0px !important;\r\n  margin-top: 5px;\r\n  @include respond-to('small'){ \r\n    margin-top: 0px !important;\r\n  }\r\n}\r\n\r\n.content-infoqsn{\r\n  padding: 0px !important;\r\n  margin-top: 10px;\r\n}\r\n\r\n.kme-content{\r\n  margin-top: -7px !important;\r\n}\r\n\r\n.zte-heading{\r\n  margin-left: 27px;\r\n}\r\n\r\n.googleAccount{\r\n  margin-top: 15px !important;\r\n}\r\n\r\n.orgInfo{\r\n  margin-left: 6px !important;\r\n}\r\n\r\n// disabled tiles tooltip style\r\n\r\n.tooltip-text-disable {\r\n  width:200px;\r\n  display: none;\r\n  position: absolute;\r\n  border-color: #333;\r\n  border: 1px solid #ccc;\r\n  background: #fff;\r\n  // text-align: center;\r\n  border-radius: 6px;\r\n  padding: 10px;\r\n  margin-left: -60px;\r\n  font-size: 12px;\r\n  z-index:9999999;\r\n  pointer-events: none;\r\n  box-shadow: 0px 5px 12px 0px rgba(#000, 0.059);\r\n}\r\n\r\n.inputField-name{\r\n margin: 20px 0 5px 0;\r\n}\r\n\r\n.error-msg{\r\n  margin: 14px 0 10px 38px !important;\r\n  padding-right: 30px;\r\n}\r\n\r\n.error1-msg{\r\n  margin: -10px 0 10px 36px !important;\r\n}\r\n\r\n.err-msg{\r\n  @include respond-to (small){\r\n    margin-top: 10px !important;\r\n    margin-bottom: 10px !important;\r\n  }\r\n}\r\n\r\n.err1-msg{\r\n  @include respond-to (small){\r\n    margin-left: 25px;\r\n    margin-top: -4px !important;\r\n    margin-bottom: 10px !important;\r\n  }\r\n}\r\n\r\n.kme-p{\r\n  margin-top: -10px !important;\r\n}\r\n\r\n.kme-field{\r\n  margin-top: -17px;\r\n}\r\n\r\n.kmeContent{\r\n  margin-top: 0px !important;\r\n}\r\n.back-btn:focus,\r\n.continue-btn:focus,\r\n.understand-btn:focus {\r\n  outline: 1px dotted #00388F;\r\n  outline-offset: 2px !important;\r\n}\r\n.continue-btn:focus-visible,\r\n.back-btn:focus-visible,\r\n.home-btn:focus-visible,\r\n.center-button:focus-visible,\r\n.understand-btn:focus-visible {\r\n  box-shadow: 0 0 0 2px #00388F;\r\n}\r\n.orgId-input:focus-visible,\r\n.orgId-input-zte:focus-visible,\r\n.field:focus-visible,\r\n.form-input:focus-visible,\r\n.google-input:focus-visible,\r\n.google-field:focus-visible,\r\n.product-selection-container input[type=\"text\"]:focus-visible {\r\n  border-color: #00388F;\r\n  box-shadow: 0 0 0 1px #00388F;\r\n}\r\n.radio-group input[type=\"radio\"]:focus-visible + .skin,\r\n.radio-btn input[type=\"radio\"]:focus-visible + .skin,\r\n.radio-button input[type=\"radio\"]:focus-visible + .skin {\r\n  border-color: #00388F;\r\n  box-shadow: 0 0 0 2px #00388F;\r\n}\r\n\r\n.product-selection-page a:focus-visible,\r\n.product-selection-container a:focus-visible,\r\n.cancel-link:focus-visible {\r\n  box-shadow: 0 0 0 2px #00388F;\r\n}\r\n.copy-icon:focus-visible {\r\n  box-shadow: 0 0 0 2px #00388F;\r\n}\r\n\r\n.alert-warning {\r\n  background-color: orange;\r\n}\r\n// .tooltip-container-disable:hover .tooltip-text-disable {\r\n//   display: block;\r\n//   opacity: 1;\r\n// }\r\n\r\n// .tooltip-text-disable::after {\r\n//   content: \"\";\r\n//   position: absolute;\r\n//   top: 100%; /* Position at the bottom of the tooltip */\r\n//   left: 50%;\r\n//   margin-left: -5px; /* Half of the notch's width to center it */\r\n//   border-width: 5px; /* Adjust for notch size */\r\n//   border-style: solid;\r\n//   border-color: #333 transparent transparent transparent; /* Solid color for the visible border, transparent for others */\r\n// }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
